import { Directive, Input, Output, Component, EventEmitter, OnInit, HostListener, ElementRef, } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { urls } from '../../config/urls';

import swal from 'sweetalert2/dist/sweetalert2.js'
import *as $ from 'jquery';

const countries = require('./countries.json');

declare function require(arg:string): any;


@Component({
  selector   : 'mbx-esscalo-admin',
  templateUrl: './esscalo-admin.template.html',
  styleUrls: ['./esscalo-admin.css', '../styles/mbx-custom.css', '../styles/esscalo.css'],
  providers: [urls],
})
export class EsscaloAdminComponent implements OnInit {

	private countries_data 		: any = countries;
	private _quotes_data 		: any = [];
	private totalPages			: any;
	private pages_ 				: any;
	private resChangeStatus 	: any;
	private _insuredList		: any;
	public _contractors_data_ 	: any = [];

	_pag_config = { count: 0, next: '', previous: ''};

	en_construccion = require('../../assets/images/En-construccion.jpg');

	bsConfigStart = {
		dateInputFormat: 'DD/MM/YYYY',
		containerClass: 'theme-dark-blue'
	};

	bsConfigEnd = {
		dateInputFormat: 'DD/MM/YYYY',
		containerClass: 'theme-dark-blue'
	};

	bsConfigFactura = {
		dateInputFormat: 'DD/MM/YYYY',
		dateOutputFormat: 'DD/MM/YYYY',
		containerClass: 'theme-dark-blue',
		showWeekNumbers: false,
	}

	// Banderas para validacion de fechas de inicio y fin
	fechaInicioValido: boolean = true;
	fechaFinValido: boolean = true;

	// Banderas para validacion de fechas de factura
	fechaFacturaValido: boolean = true;
	fechaFacturaPagoValido: boolean = true;

	// Variable en MXN para validar la moneda del certificado
	tipoMonedaMXN: string = 'MXN';

	badge = 1;
	currency = "USD"
	showModalContainer = false;
	value_disabled = false;
	is_download=false;
	is_download_certificates =false;

	step;
	data = {
		nombre_razon_social: '',
		direccion_fiscal: '',
		rfc_asegurado: '',
		contratante: '',
		direccion_contratante: '',
		rfc_contratante: '',
		descripcion_mercancia: ''
	};

	categories = {
		contratante: false,
		cliente: false,
		mercancia: false,
		transporte: false,
		valor: false,
		tarifa: false,
		certificado: false
	};

	quote_status = [
		{ value: 0, name: 'Incompleta'},
		{ value: 1, name: 'Pendientes'},
		{ value: 2, name: 'Emitidas'},
		{ value: 3, name: 'Canceladas'}
	];

	factura_cargaquote_json = {
	    cargaquote_id: null,
		fecha_factura: "", //new Date(),
        fecha_pago: "", //new Date(),
        monto: 0,
        iva: 0,
        total: 0,
        numero: "",
        pagado: false,
        comentario: "",
	};
	comision_cargaquote_json = {
	    cargaquote_id: null,
		fecha_pago_cliente: null,
        fecha_pago_asesor_venta: null,
        comentario: "",
	};

	valores_moneda = {
		mxn: 1,
		usd: 19.21,
		euro: 22.21
	};
	success_certificate_id;


	quote: any = {
		tipo_mercancia: null,
		compania: null,
		descripcion_mercancia: null,
		tipo_embalaje: null,
		cobertura_contenedor: false,
		tipo_contenedor: null,
		medidas_seguridad: null,
		numero_pedimento_referencia: null,
		numero_sello: null,
		numero_contenedor: null,
		rc_errores_omisiones: false,
		valor_mercancia: null,
		flete: null,
        impuestos_nacionales: null,
		lucro_cesante: 0,
        subtotal: null,
        gastos_adicionales: null,
        total: null,
        tipo_cambio_eur: this.valores_moneda.euro,
        tipo_cambio_mxn: this.valores_moneda.mxn,
        tipo_cambio_usd: this.valores_moneda.usd,
        prima_venta: null,
        linea_transportista: null,
        transporte_nacional: false,
        importacion: false,
        exportacion: false,
        operador: null,
        importacion_desde: '',
        importacion_hasta: '',
        exportacion_desde: null,
        exportacion_hasta: null,
        observaciones: null,
        solicitado_por: null,
        valor_mercancia_exchange: null,
        flete_exchange: null,
        impuestos_nacionales_exchange: null,
        insured: null
	};

	user_ = [{
		'email': '',
		'tel': '',
		'contact': ''
	}];

	type_product = [
		{value: 1, name: 'Mercancía General'},
		{value: 2, name: 'Vehiculos'},
		{value: 3, name: 'Refrigeradores'},
		{value: 4, name: 'Electrónicos'},
		{value: 5, name: 'Químicos'},
		{value: 6, name: 'Romplibles'}
	];

	type_container = [
		{id: 1, value: 4000, prima: 6, name: 'Standard 20 Pulgadas'},
		{id: 2, value: 5000, prima: 8, name: 'Standard 40 Pulgadas'},
		{id: 3, value: 8000, prima: 10, name: 'High Cube 40 Pulgadas'},
		{id: 4, value: 35000, prima: 35, name: 'Reefer 20 Pulgadas'},
		{id: 5, value: 45000, prima: 40, name: 'Reefer 40 Pulgadas'},
		{id: 6, value: 35000, prima: 35, name: 'Open Top'},
		{id: 7, value: 38000, prima: 35, name: 'Isotanque'},
		{id: 8, value: 15000, prima: 25, name: 'Flat'},
		{id: 9, value: 30000, prima: 30, name: 'Open Side'},
	];

	companies = [
		{value: 1, name: 'JAH'},
		{value: 2, name: 'Banorte'}
	];

	transport = [
	// 	{value: 1, name: 'Aéreo'},
	// 	{value: 2, name: 'Marítimo'}
	];

	coverage = [
		{value: 1, name: 'Total Loss'},
		{value: 2, name: 'Full Cover'},
		{value: 3, name: 'Full Cover Plus'}
	];

	tasa = [
		{value: 1, name: '22%'}
	];

	transporte_types = [
		{ value: 1,  name: 'Aereo' 				  },
		{ value: 2,  name: 'Ferrocarril' 		  },
		{ value: 3,  name: 'Barco' 				  },
		{ value: 4,  name: 'Camiones propios' 	  },
		{ value: 5,  name: 'Camiones de terceros' },
		{ value: 6,  name: 'Camiones combinados'  },
		{ value: 7,  name: 'Multimodal' 		  }

	];

	c_armados = [
		{ value: 1,  name: 'SI' },
		{ value: 2,  name: 'NO' }
	];

	hours_data = [
		{ value: 1, name: '1:00' },
		{ value: 2, name: '2:00' },
		{ value: 3, name: '3:00' },
		{ value: 4, name: '4:00' },
		{ value: 5, name: '5:00' },
		{ value: 6, name: '6:00' },
		{ value: 7, name: '7:00' },
		{ value: 8, name: '8:00' },
		{ value: 9, name: '9:00' },
		{ value: 10, name: '10:00' },
		{ value: 11, name: '11:00' },
		{ value: 12, name: '12:00' },
		{ value: 13, name: '13:00' },
		{ value: 14, name: '14:00' },
		{ value: 15, name: '15:00' },
		{ value: 16, name: '16:00' },
		{ value: 17, name: '17:00' },
		{ value: 18, name: '18:00' },
		{ value: 19, name: '19:00' },
		{ value: 20, name: '20:00' },
		{ value: 21, name: '21:00' },
		{ value: 22, name: '33:00' },
		{ value: 23, name: '23:00' },
		{ value: 24, name: '24:00' }
	];

	type_packaging = [
		{ value: 1, name: 'Contenedor' },
		{ value: 2, name: 'Pallets' },
		{ value: 3, name: 'Caja cartón' },
		{ value: 4, name: 'Carga suelta' },
		{ value: 6, name: 'Caja seca' },
		{ value: 5, name: 'Otro' }
	];

	container = [];
	containers = [];

	startMinDate: Date;
	startMaxDate: Date;

	endMinDate: Date;
	endMaxDate: Date;

	option_contractor = 1;
	contractor_filter;
	contract_info;
	contractor_selected;
	load_selected;

	quote_1;
	quote_2;
	quote_3;
	step_ = 1;

	user_info;
	admin = false;
	admin_full = false;
	client_data;

	gastos_adicionales;
	quote_selected;
	quote_back;
	show_dates_em;

	data_insured = {
		nombre: '',
		email: '',
		telefono: '',
		direccion: '',
		rfc: '',
		pais: '',
		ciudad: ''
	};
	insured_option;

	load_selected_branch = 1;

	search_params : any = {
		cadena: '',
		status : '',
		contratante: '',
		asegurado: '',
		cotizacion: '',
		poliza: '',
		fecha_inicio: '',
		fecha_fin: '',
		collapsable: false,
		is_admin: this.admin,
		paid_out: 0,
		usuario: ''
	};

    meses = new Array ("Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre");


	data_services;
	_commodity_list;
	_coverages_list;
	cobertura_list;
	security_measures;
	edit = false;
	doble = false;
	quote_list = {} as any;
	limite_despacho;
	gas_add;
	quote_cobertura;
	edit_document = false;
	file_selected = {};

	rate_exchange;
	rate_exchange_mxn;
	rate_exchange_usd;
	rate_exchange_eur;

	valor_type = 'mxn';
	flete_type = 'mxn';
	impuestos_type = 'mxn';
	operacion_type = 'mxn';
	currency_total = 'mxn';

	valor_mecancia;
	valor_flete;
	valor_impuestos;
	valor_lucro_cesante;
	valor_operacion;

	_containers_list;
	percent_value_ = false;
	free_container = false;
	free;

	referancia1;
	referancia2;
	inicioFecha;
	finFecha;

	adquisicion_ge;
	profit_client_percent;
	coberage_full;
	is_search = false;
	currency_pattern = '^(\d{1,3})(,\d{1,3})*(\.\d{1,})?$';
	countries;
	cols_desde;
	cols_hasta;

	contratanteSeleccionado: any;

	// contenedores
	contenedores = [
		{ nombre: 'Estándar Seco 20\'', monto: 8000, moneda: 'USD', primaMinima: 3.6 },
		{ nombre: 'Estándar Seco 40\'', monto: 12000, moneda: 'USD', primaMinima: 5.4 },
		{ nombre: 'High Cube Seco 40\'', monto: 12000, moneda: 'USD', primaMinima: 5.4 },
		{ nombre: 'Flat', monto: 40000, moneda: 'USD', primaMinima: 20 },
		{ nombre: 'Open Side', monto: 40000, moneda: 'USD', primaMinima: 20 },
		{ nombre: 'Open Top', monto: 35000, moneda: 'USD', primaMinima: 17.5 },
		{ nombre: 'Reefer 20\'', monto: 35000, moneda: 'USD', primaMinima: 17.5 },
		{ nombre: 'Reefer 40\'', monto: 50000, moneda: 'USD', primaMinima: 25 },
		{ nombre: 'Isotanque', monto: 50000, moneda: 'USD', primaMinima: 25 },
	];
	contenedorSelect = this.contenedores[0]; // contenedor seleccionado actual (por defecto el primero)

	// enum contenedor
	enumContenedor = {
		Contenedor: 'Contenedor', // Contenedor
		MaqGeneral: 'Maquinaria en general', // Maquinaria en general -> remover
	};

	// enum aseguradora
	enumAseguradora = {
		ChubbUsd: 'CHUBB USD'
	};

	// variable para alojar la aseguradora seleccionada
	aseguradoraActual: string = '';

	@Input()
		set esc_step (data: any) {
			this.step = data;
			this.step_ = data;
		}

	@Input()
		set contractorsDatasource (data: any) {
			if(data) {
				this.is_search = false;
				// console.log('-----------------------------');

				this._contractors_data_ = data;
				this.showContractInfo(data[0]);
			}
		}

	@Input()
		set contractorAdded (data: any) {

			if(data) {

				this.contractor_selected = data;
				localStorage['contractor_selected'] = JSON.stringify(this.contractor_selected);
				localStorage['contractor_selected_'] = JSON.stringify(this.contractor_selected);

				// this.step_ = 2;
				this.changeStep(2);
			}

		}

	@Input()
		set responseQuote(data: any) {
			this.contractor_selected = null;
			this.quote_1 = null;
  			this.quote_2 = null;
  			this.quote_3 = null;
  			this.clearQuote();
		}

	@Input()
		set updateQuoteResult(data:any) {
			this.returnToList()

		}

	@Input()
		set resultFullList(data:any) {
			this.is_download = false;
			if(data) {
				// aqui
				// this.search_params = {
				// 	status : '',
				// 	contratante: '',
				// 	asegurado:  '',
				// 	cotizacion: '',
				// 	poliza: '',
				// 	fecha_inicio: '',
				// 	fecha_fin: '',
				// };

				this._quotes_data = data;
				console.log("1 this._quotes_data: ", this._quotes_data)
				for (var i = 0; i < this._quotes_data.length; i++) {
					if(this._quotes_data[i].tasa == null){
						this._quotes_data[i].tasa = 0;
					}
				}
			}
		}

	@Input()
	  set pagConfig(data: any) {

	  	if(data) {
		  	this._pag_config = { count: 0, next: '', previous: ''};
		  	this.totalPages = [];
		  	this._pag_config = data;

		  	if(this._pag_config) {
		  		this.pages_ = Math.ceil(this._pag_config['count'] / 10);
		  		for (var i = 0; i < this.pages_; i++) {
		       		this.totalPages.push(i+1);
		      	}
		  	}
	  	}

	  }

	@Input()
		set insuredList(data: any) {
			if(data) {
				this._insuredList = data;
				// console.log('_insuredList', this._insuredList);
			}
		}

	@Input()
		set getDatasource(data: any) {
			if(data) {

				this._quotes_data = data;
				console.log("2 this._quotes_data: ", this._quotes_data)

			}
			this.is_download=false;
		}

	// Señal del spinner
	@Input() set signal(signal: any) {
		if (signal) {
			this.is_download = true;
		} else {
			this.is_download = false;
		}
	}

	@Input()
		set getCertificatesDownload(data: any) {
			if(data) {

				this._quotes_data = data;

			}
			this.is_download_certificates=false;
		}

	@Input()
		set resultReport(data: any) {
			if(data) {
				this._quotes_data = data;
			}
			this.is_download=false;
		}
	@Input()
		set resultInsurances(data: any) {
			if(data) {
			}
		}


	@Input()
		set servicesData(data: any) {
			if (data) {
				let aseguradoras = data.results;
				let array_aseguradoras = [];
				//this.data_services = array_aseguradoras;
				this.data_services = data.results;
				if(this.data_services && this.quote_selected){
					for(var i = 0; i < this.data_services.length; i ++){
						if(this.quote_selected.service == this.data_services[i].id){
							this.quote_selected.compania = this.data_services[i];
						}
					}
				}
			}
			this.removerContenedorMercancia(); // remueve el contenedor de la lista de servicios
		}

	@Input()
		set commodityList(data: any) {
			if (data) {
				if (!data.name) {
					this._commodity_list = data.results;
					if(this._commodity_list && this.quote_selected){
						for(var i = 0; i < this._commodity_list.length; i ++){
							if(this.quote_selected.tipo_mercancia.name == this._commodity_list[i].name){
								this.quote_selected.tipo_mercancia = this._commodity_list[i];
								this.selectCommodity(this.quote_selected.tipo_mercancia);
							}
						}
					}
				}
			}

			this.removerContenedorMercancia(); // remueve el contenedor de la lista de commodities
		}

	@Input()
		set coveragesList(data: any) {
			if (data) {
				// this._coverages_list = [
				// 	{ 'name': data['0'] },
				// 	{ 'name': data['1'] },
				// 	{ 'name': data['2'] },
				// 	{ 'name': data['4'] }
				// ];

				/**
				 * "json": [
					"Door to door",
					"Port to port",
					"Port to door",
					"Port to airport",
					"Door to port",
					"Airport to door",
					"Door to airport",
					"Airport to port",
					"Airport to airport"
					]
				*/

				// se colocan todas las coberturas disponibles (se incluyen las opciones de airport)
				this._coverages_list = [
					{ 'name': data['0'] },
					{ 'name': data['1'] },
					{ 'name': data['2'] },
					{ 'name': data['3'] },
					{ 'name': data['4'] },
					{ 'name': data['5'] },
					{ 'name': data['6'] },
					{ 'name': data['7'] },
					{ 'name': data['8'] },
				];
			}
		}

	@Input()
		set resultExchange(data: any) {

			if (data) {
				this.rate_exchange = data;
				this.rate_exchange_mxn = 1;
				this.rate_exchange_usd = parseFloat(data.dolar);
				this.rate_exchange_eur = parseFloat(data.euro);
			}
		}

	@Input()
		set containersList(data: any) {
			if (data) {
				for (let i in data) {
					let item = (data[i].type).replace('PULGADAS', 'PIES');
					data[i].type = item;
				}

				this._containers_list = data;
			}
		}
	@Input()
		set countries_list(data: any) {
			if (data) {
				this.countries = data;
			}
		}
	@Input()
	set dataDesde(data: any) {
		if (data) {
			if (!this.quote_list.desde) {
				this.quote_list.desde = {} as any;
				this.quote_list.desde.details = {} as any;
			}
			this.quote_list.desde.city  = data.municipio;
			this.cols_desde = data.colonias;
			if (this.cols_desde.length == 1) {
				this.quote_list.desde.details.colony = this.cols_desde[0].name;
			}
		}
	}

	@Input()
	set dataHasta(data: any) {
		if (data) {
			if (!this.quote_list.hasta) {
				this.quote_list.hasta = {} as any;
				this.quote_list.hasta.details = {} as any;
			}
			this.quote_list.hasta.city = data.municipio;
			this.cols_hasta = data.colonias;
			if (this.cols_hasta.length == 1) {
				this.quote_list.hasta.details.colony = this.cols_hasta[0].name;
			}
		}
	}

	@Output() returnMenu 		= new EventEmitter();
	@Output() contractorsFilter = new EventEmitter();
	@Output() addContractor 	= new EventEmitter();
	@Output() saveQuote			= new EventEmitter();
	@Output() getFullList 		= new EventEmitter();
	@Output() getContractors 	= new EventEmitter();
	@Output() saveStatus		= new EventEmitter();
	@Output() reqInsured		= new EventEmitter();
	@Output() getListInsured	= new EventEmitter();
	@Output() reqData			= new EventEmitter();
	@Output() reqQuoteStatus	= new EventEmitter();
	@Output() specificQuote		= new EventEmitter();
	@Output() reqInsurancesClient = new EventEmitter();
	@Output() paramsQuotes  	= new EventEmitter();
	@Output() export  			= new EventEmitter();
	@Output() exportCert		= new EventEmitter();
	@Output() sendPdfData 		= new EventEmitter();
	@Output() quoteEdition	 	= new EventEmitter();
	@Output() paidOut	 		= new EventEmitter();
	@Output() reqEliminar	 	= new EventEmitter();
	@Output() getServices 		= new EventEmitter();
	@Output() getCommonCom 		= new EventEmitter();
	@Output() getRateExchange 	= new EventEmitter();
	@Output() getContainers 	= new EventEmitter();
	@Output() emitirQuotes 		= new EventEmitter();
	@Output() quoteDoble 		= new EventEmitter();
	@Output() duplicateQuote 	= new EventEmitter();
	@Output() getCountries = new EventEmitter();
	@Output() cpParam = new EventEmitter();
	@Output() facturaCreate 	= new EventEmitter();
	@Output() facturaEdit       = new EventEmitter();
	@Output() comisionCreate 	= new EventEmitter();
	@Output() comisionEdit      = new EventEmitter();
	@Output() documentFileEdit  = new EventEmitter();


	constructor(private uris: urls ) {
		// this.bsValue = ' ';

		this.startMinDate = new Date();
		if (localStorage['admin_full']=='true'){
			this.startMinDate = new Date(2000,0,1);
		} else if(localStorage['admin']=='true'){
			this.startMinDate.setDate(this.startMinDate.getDate() - 7);
		}
		this.startMinDate.setDate(this.startMinDate.getDate());

		this.startMaxDate = new Date();
		this.startMaxDate.setDate(this.startMaxDate.getDate() + 120);


	}

	ngOnInit() {
		this.getCountries.emit('ok');

		if(!this._quotes_data.length) {
			this.reqData.emit('ok');
		}

		if(sessionStorage['user_info']) {
			this.user_info = JSON.parse(sessionStorage['user_info']);
		}

	  	if(localStorage['step_']) {
	  		this.step_ = parseInt(localStorage['step_']);
	  		this.step = this.step_;
	  	} else {
	  		this.step = 1;
			localStorage['step_'] = this.step_;
	  	}


	  	if(localStorage['admin']) {
	  		this.admin = true;
	  		this.search_params.is_admin = this.admin;
	  	}
		if (localStorage['admin_full']=='true'){
			this.admin_full = true;
		}else {
			this.admin_full = false;
		}

	  	if(localStorage['client_group']) {
	  		this.client_data = JSON.parse(localStorage['client_group']);
	  		this.search_params.contratante = this.admin ? '' : this.client_data.id;
	  	}

	  	if(localStorage['data']) {
	  		this.data = JSON.parse(localStorage['data']);
	  	}

	  	if(localStorage['contractor_selected']) {
	  		if(localStorage['contractor_selected'] !== 'undefined') {
	  			this.contractor_selected = JSON.parse(localStorage['contractor_selected_']);
	  		}
	  	}

	  	if(localStorage['quote_1']) {
	  		this.quote = JSON.parse(localStorage['quote_1']);
	  		this.quote_1 = this.quote;
	  	}

	  	if(localStorage['quote_2']) {
	  		this.quote = JSON.parse(localStorage['quote_2']);
	  		this.quote_1 = null;
	  		this.quote_2 = this.quote;
	  	}

	  	if(localStorage['quote_3']) {
	  		this.quote = JSON.parse(localStorage['quote_3']);
	  		this.quote_1 = null;
	  		this.quote_2 = null;
	  		this.quote_3 = this.quote;

	  		if(this.quote.importacion) {

		  		let _importacion_desde = this.quote.importacion_desde.substring(0, 10);
		  		let _imprt_desde = (_importacion_desde).split('-');

		  		let _importacion_hasta = this.quote.importacion_hasta.substring(0, 10);
		  		let _imprt_hasta = (_importacion_hasta).split('-');

		  		this.quote.importacion_desde = _imprt_desde[2] + '/'+ _imprt_desde[2] + '/' + _imprt_desde[0];
		  		this.quote.importacion_hasta = _imprt_hasta[2] + '/'+ _imprt_hasta[2] + '/' + _imprt_hasta[0];
	  		}

	  		if(this.quote.exportacion) {

		  		let _exportacion_desde = this.quote.exportacion_desde.substring(0, 10);
		  		let _exprt_desde = (_exportacion_desde).split('-');

		  		let _exportacion_hasta = this.quote.exportacion_hasta.substring(0, 10);
		  		let _exprt_hasta = (_exportacion_hasta).split('-');

		  		this.quote.exportacion_desde = _exprt_desde[2] + '/'+ _exprt_desde[2] + '/' + _exprt_desde[0];
		  		this.quote.exportacion_hasta = _exprt_hasta[2] + '/'+ _exprt_hasta[2] + '/' + _exprt_hasta[0];
	  		}
	  	}

	  	if(localStorage['step']) {
	  		this.step = parseInt(localStorage['step'])
	  	}

	  	this.getRateExchange.emit('ok');
		  let data = {
			all:true,
	    	cadena : '',
	    	autocomplete : true
		}

		this.contractorsFilter.emit(data);
	}

	//---- typeahead ----

	  string_;
	  query3 = '';

	  cadena(param) {
		this.is_search = true
	    console.log('param', param);
	    // enviar valor de cadena
	    // param['autocomplete'] = true;
	    let data = {
			all:true,
	    	cadena : param,
	    	autocomplete : true
		}
		if(!this.search_params.contratante || !param) {
			if (!param){
				this.search_params.contratante ='';
			}
			this.search_params.cadena = param;

		}

		this.contractorsFilter.emit(data);

	  }

	  handleStaticResultSelected (result) {

	    // console.log('ya seleccionaste: ', result);
	    // console.log(result.item.id);
	    this.search_params.contratante = result.item.id;
		this.search_params.asegurado = 0;
	    this.query3 = result;
	    let data = {
	    	cadena: '',
	    	grupo: result.item.id
	    };

		this.getListInsured.emit(data);


	  }

	validarContratante() {
		if (!this.contratanteSeleccionado){
			this.search_params.contratante = '';
			this.search_params.asegurado = 0;
			this._insuredList = [];
		}
	}

	// end ----- typeahead

	validateSecurity() {
		let _v_mercancia = (this.convertCurrency(this.quote_list.valor_mercancia, this.valor_type)).toFixed(2);

		if(this.quote_list.compania.name == 'JAH') {
			let x  = (this.convertCurrency(this.quote_list.valor_mercancia, this.valor_type)).toFixed(2);
			_v_mercancia =  (parseFloat(x) / this.rate_exchange_usd).toFixed(2);
		}

		if(this.quote_list.compania.name == 'GNP MXN') {

			if(this.quote_list.rate.name.name == "Terrestre") {
				// corroborar que sea en MXN
				if(parseFloat(_v_mercancia) > 2500000) {
					alert('Dentro de México se requiere cumplir con los requisitos de seguridad indicados: GPS + Custodia Virtual y / o GPS + Custodia Física');
				}
			}

		} else if(this.quote_list.compania.name == 'JAH') {

			if(this.quote_list.rate.name.name == "Terrestre") {
				// cheacar que onda con los dolares
				if(parseFloat(_v_mercancia) > 1 && parseFloat(_v_mercancia) <= 100000) {

					alert('Dentro de México se requiere cumplir con los requisitos de seguridad indicados: GPS');

				} else if(parseFloat(_v_mercancia) > 100000 && parseFloat(_v_mercancia) <= 150000) {

					alert('Dentro de México se requiere cumplir con los requisitos de seguridad indicados: GPS + Custodia Virtual');

				} else if(parseFloat(_v_mercancia) > 150000) {

					alert('Dentro de México se requiere cumplir con los requisitos de seguridad indicados: GPS + Custodia Física');
				}
			}
		}
	}

	calcProfitClientPer(parItem) {

		// let tarifa_ = '0.00';
		let tarifa_ = this.getTarifa(parItem);
		let tasa_venta = parseFloat(parItem.tasa);
		let tarifa	   = parseFloat(tarifa_);

		this.profit_client_percent = tasa_venta - tarifa;
		if(isNaN(this.profit_client_percent)) {
			this.profit_client_percent = 0.00;
		}
		if(this.profit_client_percent < 0){
			this.profit_client_percent = this.profit_client_percent * -1;
		}

		return this.profit_client_percent.toFixed(2);

	}

	calcProfitClientImp(parItem) {

		let percent =  parseFloat(this.calcProfitClientPer(parItem)) / 100;
		let prima_neta = parseFloat(parItem.total);
		let result = (prima_neta * this.profit_client_percent)/100;
		if(isNaN(result)) {
			result = 0.00;
		}
		if(result < 0){
			result = result * -1;
		}

		return result.toFixed(2);
	}


	getProfitGe(parItem) {
		let tarifa_ = parseFloat(this.getTarifa(parItem));
		let tarifa_ge = parseFloat(this.geTarifas(parItem));

		let resultado = tarifa_ge - tarifa_;

		if(isNaN(resultado)) {
			resultado = 0.00;
		}

		if(resultado < 0){
			resultado = resultado * -1;
		}

		this.adquisicion_ge = resultado;
		return resultado.toFixed(2);
	}

	calcProfitGeImp(parItem) {
		let per_profit_ge = parseFloat(this.getProfitGe(parItem)) / 100;
		let sum_asegurada;

		if(parItem.aseguradora_name == 'JAH'){
			sum_asegurada = parseFloat(parItem.total);
		}
		else{
			sum_asegurada = parseFloat(parItem.total);
		}
		let resultado = (sum_asegurada * this.adquisicion_ge)/100;
		if(isNaN(resultado)) {
			resultado = 0.00;
		}

		if(resultado < 0){
			resultado = resultado * -1;
		}

		return resultado.toFixed(2);
	}

	geTarifas(parItem) {

		// console.log('parItem', parItem);
		if(parItem.aseguradora_name == 'HDI') {
			return '0.20';
		} else if(parItem.aseguradora_name == 'GNP MXN' || parItem.aseguradora_name == 'GNP USD'
		|| parItem.aseguradora_name == 'CHUBB USD' || parItem.aseguradora_name == 'CHUBB MXN') {
			return '0.14';
		} else if(parItem.aseguradora_name == 'JAH') {
			switch (parItem.tipo_mercancia_option) {
				case "Mercancía general":
					if(parItem.rate.cover == 1) {
						return '0.19';
					} else if(parItem.rate.cover == 2) {
						return '0.20';
					} else if(parItem.rate.cover == 3) {
						return '0.20';
					}
					break;

				case "Vehículos":
					if(parItem.rate.cover == 1) {
						return '0.20';
					} else if(parItem.rate.cover == 2) {
						return '0.22';
					} else if(parItem.rate.cover == 3) {
						return '0.22';
					}
					break;

				case "Refrigerados":
					if(parItem.rate.cover == 1) {
						return '0.20';
					} else if(parItem.rate.cover == 2) {
						return '0.40';
					} else if(parItem.rate.cover == 3) {
						return '0.40';
					}
					break;

				case "Electrónicos":
					if(parItem.rate.cover == 1) {
						return '0.26';
					} else if(parItem.rate.cover == 2) {
						return '0.40';
					} else if(parItem.rate.cover == 3) {
						return '0.40';
					}
					break;

				case "Químicos":
					if(parItem.rate.cover == 1) {
						return '0.20';
					} else if(parItem.rate.cover == 2) {
						return '0.22';
					} else if(parItem.rate.cover == 3) {
						return '0.22';
					}
					break;

				case "Rompibles":
					if(parItem.rate.cover == 1) {
						return '0.20';
					} else if(parItem.rate.cover == 2) {
						return '0';
					} else if(parItem.rate.cover == 3) {
						return '0';
					}
					break;

				default:
					// code...
					break;
			}
		}
	}


	exportData() {
		if(!this.search_params.status) {
			this.search_params.status =0;
		}
		if(!this.search_params.contratante) {
			this.search_params.contratante =0;
		}
		if(!this.search_params.asegurado) {
			this.search_params.asegurado =0;
		}
		if(!this.search_params.cotizacion) {
			this.search_params.cotizacion =0;
		}
		if(!this.search_params.poliza) {
			this.search_params.poliza =0;
		}
		if(!this.search_params.fecha_inicio) {
			this.search_params.fecha_inicio =0;
		}
		if(!this.search_params.fecha_fin) {
			this.search_params.fecha_fin =0;
		}

		this.export.emit(this.search_params);

	}

	exportCertificates(){
		let data = {
			"start_date": this.search_params.fecha_inicio,
			"end_date": this.search_params.fecha_fin,
			"contrator":  this.search_params.contratante
		}
		//this.is_download_certificates=true;
		this.exportCert.emit(data);
	}
	Pagar(parStatus) {
		this.paidOut.emit(parStatus);


	}

	Eliminar(parId, quote) {
		swal.fire({
		  title: '¡Cuidado!',
		  text: "¿Seguro que desea eliminar el registro?",
		  type: 'warning',
		  showCancelButton: true,
		  confirmButtonColor: '#3085d6',
		  cancelButtonColor: '#d33',
		  confirmButtonText: 'Aceptar'
		}).then((result) => {
		  if (result.value) {
		  	this.reqEliminar.emit(parId);
		  	this._quotes_data.splice(this._quotes_data.indexOf(quote), 1);
		  }
		})



	}

	getTarifa(parItem) {

		let tipo_mercancia = parItem.tipo_mercancia_option;
		let tarifa = '0.00'


		if(parItem.tarifa_quote){
			if(parItem.tarifa_quote == '0.00'){
				for(let i in parItem.mercancias) {

					if(parItem.mercancias[i].name == tipo_mercancia) {
						if(parItem.mercancias[i].paquete_mercancia.length == 1) {
							tarifa = parItem.mercancias[i].paquete_mercancia[0].tarifa;
							parItem['tarifa_asginada'] =  tarifa;
							break;

						} else {

							let paquetes_mercancias_ = parItem.mercancias[i].paquete_mercancia;
							for(let j in paquetes_mercancias_) {
								if(paquetes_mercancias_[j].cobertura == 'TOTAL LOSS' && parItem.rate.cover == 1 ||
									paquetes_mercancias_[j].cobertura == 'FULL COVER' && parItem.rate.cover == 2 ||
									paquetes_mercancias_[j].cobertura == 'FULL COVER PLUS' && parItem.rate.cover == 3) {
									tarifa = paquetes_mercancias_[j].tarifa;
									parItem['tarifa_asginada'] =  paquetes_mercancias_[j].tarifa;
									break;
								}
							}
							break;
						}
					}
				}

			}
			else if(parItem.tarifa_quote != null || parItem.tarifa_quote != undefined){
				tarifa = parItem.tarifa_quote;
			}
			else{
				tarifa = '0.00';
			}
		}
		else{
			tarifa = '0.00';
		}
		// console.log('****', tarifa);

		// console.log('aaaa', tarifa);
		return tarifa;


	}

	folioEmision(parItem) {

		let date = new Date(parItem.fecha_inicio);

		let folio = String(date.getFullYear().toString().substr(-2)) +'.'+String(date.getMonth() +1)+'.'+String(date.getDate())+'.'+ String(parItem.id)+'.' +parItem.numero_certificado;

		let folio_na = 'NA';

		if(parItem.status == 3) {
			return folio;
		} else {
			return folio_na;
		}

	}

	selectStatusFilter(param) {
		if(param == '0') {
			// console.log(this.search_params);
			this.search_params.operador = '';
			// this.search_params.
			this.string_ = '';

		}
	};

	insuredSearch(param) {

		this.insured_option = param;

		if(param == 2) {
			// hacer llamada lista de beneficiarios
			// console.log('********');
			this.getListInsured.emit('ok');
		}

	}

	saveInsured() {
		// data_insured
		this.reqInsured.emit(this.data_insured);
	}

	// contractorFilter(_contractor) {
	// 	this.contractorsFilter.emit(_contractor);
	// };

	changeCoberage(){
		if (this.quote_selected.compania.name == 'JAH') {
			if (this.quote_cobertura.cobertura == 'FULL COVER PLUS') {
				this.quote_selected.rate.cover = 3;
				this.quote_selected.rc_errores_omisiones = true;
				this.coberage_full = true;
			} else if (this.quote_cobertura.cobertura == 'FULL COVER'){
				this.quote_selected.rate.cover = 2;
				this.quote_selected.rc_errores_omisiones = false;
				this.coberage_full = false;
			} else {
				this.quote_selected.rate.cover = 1;
				this.quote_selected.rc_errores_omisiones = false;
				this.coberage_full = false;
			}
		} else {
			this.quote_selected.rc_errores_omisiones = false;
			this.coberage_full = false;
		}
		this.quote.transporte = '';
	};

	changeStep(param) {
		switch (param) {
			case 1:
				// code...
				this.contractor_selected = null;
				this.step_ = 1;
				this.step = 1;
				this.returnToList();

				break;
			case 2:
				this.contractor_selected = JSON.parse(localStorage['contractor_selected_']);
				this.quote_1 = null;
				this.quote_2 = null;
				this.step_ = 2;
				break;
			case 3:
				this.contractor_selected = JSON.parse(localStorage['contractor_selected_']);
				this.quote_1 = this.quote;
				this.quote_2 = null;
				this.step_ = 3;
				break;
			case 4:
				this.contractor_selected = JSON.parse(localStorage['contractor_selected_']);
				this.quote_1 = null;
				this.quote_2 = this.quote;
				this.step_ = 4;
				break;
			case 5:

				this.getFullList.emit();
				this.contractor_selected = null;
				this.quote_1 = null;
				this.quote_2 = null;
				this.step = 5;
				this.step_ = 5;
				break;

			default:
				// code...
				break;
		}
	};

	showContractInfo(param) {

		this.contract_info = null;
		this.contract_info = param;

		for(let i in this._contractors_data_) {

			let item = this._contractors_data_[i];

			if(param.id == item.id) {
				param.selected = true;
			} else {
				item.selected = false;
			}
		}
	};

	selectContractor(param) {
		this.contractor_selected = param;
		localStorage['contractor_selected'] = JSON.stringify(this.contractor_selected);
		localStorage['contractor_selected_'] = JSON.stringify(this.contractor_selected);
		this.changeStep(2);
		// this.changeForm(1);
	};

	selectContrQuote(param) {
	    if (param.factura_cargaquote == null){
	        param.factura_cargaquote = this.factura_cargaquote_json
	    }

	    if (param.comision_cargaquote == null){
	        param.comision_cargaquote = this.comision_cargaquote_json
	    }
		this.quote_selected = param;
		console.log("selectContrQuote this.quote_selected", this.quote_selected)
		this.aseguradoraActual = this.quote_selected.aseguradora_name;
		this.validarContenedorActual(); //valida si el contenedor seleccionado existe en la lista de contenedores
		localStorage['quote_back']= JSON.stringify(param);
		if (this.quote_selected.rate.transport == null){
			this.quote_selected.rate = { transport: 4, name: "Terrestre", value: true, cover: 0 };
		}
		this.contractor_selected = param;
		localStorage['contractor_selected'] = JSON.stringify(this.contractor_selected);
		localStorage['contractor_selected_'] = JSON.stringify(this.contractor_selected);

		// if(this.quote_selected.carga_quote_contratate.length) {
		// 	this.load_selected = this.quote_selected.carga_quote_contratate[0];
		// 	this.quote_selected.carga_quote_contratate[0].selected = true;
		// }
		if(parseFloat(this.quote_selected.gastos_adicionales) > 0 ){
			this.gas_add = 'si';
		}
		else{
			this.gas_add = 'no';
		}
		if(this.quote_selected.rate.name){
			if(this.quote_selected.rate.name.name){
				this.quote_selected.rate.name = this.quote_selected.rate.name.name;
			}
		}else{
			//this.quote_selected.rate.name = [];
			this.metodoDcocumental();
		}
		if(this.quote_selected.quote_type == 2){
			this.metodoDcocumental();
		}
	};

	metodoDcocumental(){
		// this.quote_selected.cargaquotefile_cargaquote.forEach(function(value){
		// 	docs += value.document+', ';
		//   })

		let arreglo = this.quote_selected.cargaquotefile_cargaquote.map((archivo: any) => archivo.document);
		let referencias = arreglo.join(', ');

		// 				this.quote_selected.asegurado_name = docs;
		//this.quote_selected.aseguradora_name = 'Documento: ' + this.quote_selected.document;
		//this.quote_selected.rate.name = [];
		//this.quote_selected.rate.name.name = 'Documento: ' + this.quote_selected.document;
		//this.quote_selected.tipo_mercancia.name = 'Documento: ' + this.quote_selected.document;
		//this.quote_selected.rate.cover = 10;
		// 				this.quote_selected.numero_pedimento_referencia = referencias;
		// 				this.quote_selected.numero_sello = docs;
		//this.quote_selected.cobertura_door_to_door = 'Documento: ' + this.quote_selected.document;
		//this.quote_selected.medidas_seguridad = 'Documento: ' + this.quote_selected.document;
		//this.quote_selected.numero_documento_contenedor = 'Documento: ' + this.quote_selected.document;
	};

	emitAfterQuote(quote){
		console.log("abreModal")
	}

	editQuote(param) {
	    // console.log("editQuote param: ",param.factura_cargaquote)
		this.getCountries.emit('ok');
		if (this.quote_selected.quote_type !=2 && this.quote_selected.quote_type !=1){
			this.col_by_zip_hasta(this.quote_selected.hasta.details.zipcode);
			this.col_by_zip_desde(this.quote_selected.desde.details.zipcode);
		}
		this.edit = true;
		this.quote_list = param;

		this.quote_selected.fecha_inicio = new Date(this.quote_selected.fecha_inicio);
		this.quote_selected.fecha_fin = new Date(this.quote_selected.fecha_fin);
		//console.log("factura_cargaquote", this.quote_selected.factura_cargaquote)

		if (this.quote_list.factura_cargaquote.fecha_factura === null) {
			this.quote_list.factura_cargaquote.fecha_factura = '';
		} else {
			this.quote_list.factura_cargaquote.fecha_factura = new Date(this.quote_list.factura_cargaquote.fecha_factura);
		}

		if (this.quote_list.factura_cargaquote.fecha_pago === null) {
			this.quote_list.factura_cargaquote.fecha_pago = '';
		} else {
			this.quote_list.factura_cargaquote.fecha_pago = new Date(this.quote_list.factura_cargaquote.fecha_pago);
		}

		// if (this.quote_selected.factura_cargaquote.fecha_factura === null){
        //     // this.quote_selected.factura_cargaquote = this.factura_cargaquote_json
        //     this.quote_selected.factura_cargaquote.fecha_factura = new Date();
        //     this.quote_selected.factura_cargaquote.fecha_pago = new Date();
		// }else{
        //     this.quote_selected.factura_cargaquote.fecha_factura = new Date(this.quote_selected.factura_cargaquote.fecha_factura);
        //     this.quote_selected.factura_cargaquote.fecha_pago = new Date(this.quote_selected.factura_cargaquote.fecha_pago);
		// }
		//console.log("comision_cargaquote quote_list", this.quote_list.comision_cargaquote)
		if (this.quote_selected.comision_cargaquote.fecha_pago_cliente !== null){
            this.quote_selected.comision_cargaquote.fecha_pago_cliente =
            new Date(this.quote_selected.comision_cargaquote.fecha_pago_cliente);
		}
		if (this.quote_selected.comision_cargaquote.fecha_pago_asesor_venta !== null){
            this.quote_selected.comision_cargaquote.fecha_pago_asesor_venta =
            new Date(this.quote_selected.comision_cargaquote.fecha_pago_asesor_venta);
		}
		//console.log("comision_cargaquote", this.quote_selected.comision_cargaquote)


		if(this.quote_list.aseguradora_name == 'JAH'){
			this.quote_selected.currency_total = 'usd';
		}
		else{
			this.quote_selected.currency_total = 'mxn';
		}

		this.getServices.emit({"id": param.contratante});

		let data = {
			grupo: param.contratante,
			service: param.service
		}

		this.getCommonCom.emit(data);

		for(var i = 0; i < this.type_packaging.length; i ++){
			if(this.quote_list.tipo_embalaje == this.type_packaging[i].value){
				this.quote_list.tipo_embalaje = this.type_packaging[i].value;
			}
		}
		if(this.quote_list.quote_type!=2){
			for(var i = 0; i < this._coverages_list.length; i ++){
				if(this.quote_list.cobertura_door_to_door.toLowerCase() == this._coverages_list[i].name.toLowerCase()){
					this.quote_list.cobertura_door_to_door = this._coverages_list[i].name;
				}
			}
		}

		if(parseFloat(this.quote_selected.gastos_adicionales) > 0 ){
			this.gas_add = 'si';
		}
		else{
			this.gas_add = 'no';
		}
		this.getContainers.emit();

		//this.onAmountChange('subtotal', { 'data': this.quote_selected.subtotal }, null);
		//this.onAmountChange('total', { 'data': this.quote_selected.total }, null);
		//this.onAmountChange('valor_mercancia', { 'data': this.quote.prima }, null);
		//this.onAmountChange('flete', { 'data': this.quote.flete }, null);
		//this.onAmountChange('impuestos_nacionales', { 'data': this.quote.impuestos_nacionales }, null);
		//this.onAmountChange('gastos_operacionales', { 'data': this.quote.gastos_operacionales }, null);
		//this.onAmountChange('prima', { 'data': this.quote.prima }, null);
		//this.onAmountChange('gran_total', { 'data': this.quote.gran_total }, null);
	};

	valorNumber(item){
		if(item){
			var valu = item.replace(/,/g, "");
			return valu;
		}
		else {
			return '';
		}
	};

	selectCommodity(param) {
		this.cobertura_list = param.paquete_mercancia;
		this.transport = [];

		if (param.service_name == 'JAH') {
			if(this.quote_selected.rate.cover == 1){
				for(var i = 0; i < this.cobertura_list.length; i ++){
					if(this.cobertura_list[i].cobertura == 'TOTAL LOSS'){
						this.quote_cobertura = this.cobertura_list[i];
					}
				}
			}
			if(this.quote_selected.rate.cover == 2){
				for(var i = 0; i < this.cobertura_list.length; i ++){
					if(this.cobertura_list[i].cobertura == 'FULL COVER'){
						this.quote_cobertura = this.cobertura_list[i];
					}
				}
			}
			if(this.quote_selected.rate.cover == 3){
				for(var i = 0; i < this.cobertura_list.length; i ++){
					if(this.cobertura_list[i].cobertura == 'FULL COVER PLUS'){
						this.quote_cobertura = this.cobertura_list[i];
					}
				}
			}

			if (this.quote_cobertura.cobertura == 'FULL COVER PLUS') {
				this.quote_selected.rc_errores_omisiones = true;
				this.coberage_full = true;
			}

			// for(var i = 0; i < this.cobertura_list.length; i ++){
			// 	if(this.quote_selected.rate.cover == 1){
			// 		this.quote_selected.rate.cobertura = this.cobertura_list[i];
			// 	}
			// }
			if (param.name == 'Mercancía general' || param.name == 'Vehículos' || param.name == 'Refrigerados' || param.name == 'Químicos') {
				this.transport = [
					{ value: 1, name: 'Aéreo', limite: 1000000 },
					{ value: 2, name: 'Marítimo', limite: 1000000 },
					{ value: 4, name: 'Terrestre', limite: 500000 },
					{ value: 6, name: 'Ferrocarril', limite: 500000 },
					{ value: 7, name: 'Multimodal', limite: 350000 }
				];

				// this.jah_transport = [
				// 	{ value: 1, name: 'Aéreo', limite: 1000000 },
				// 	{ value: 2, name: 'Marítimo', limite: 1000000 },
				// 	{ value: 4, name: 'Terrestre', limite: 500000 },
				// ];

			}
			if (param.name == 'Electrónicos') {
				this.transport = [
					{ value: 1, name: 'Aéreo', limite: 1000000 },
					{ value: 2, name: 'Marítimo', limite: 1000000 },
					{ value: 4, name: 'Terrestre', limite: 350000 },
					{ value: 6, name: 'Ferrocarril', limite: 350000 },
					{ value: 7, name: 'Multimodal', limite: 350000 }
				];
			}
			if (param.name == 'Rompibles') {
				this.transport = [
					{ value: 1, name: 'Aéreo', limite: 1000000 },
					{ value: 2, name: 'Marítimo', limite: 1000000 },
					{ value: 4, name: 'Terrestre', limite: 150000 },
					{ value: 6, name: 'Ferrocarril', limite: 150000 },
					{ value: 7, name: 'Multimodal', limite: 150000 }
				];
			}
		} else if (param.service_name == 'HDI') { // actualizacion para HDI
			if (this.quote_selected.rate.cover == 0) {
				for (var i = 0; i < this.cobertura_list.length; i++) {
					if (this.cobertura_list[i].cobertura == 'Mercancía en tránsito') {
						this.quote_cobertura = this.cobertura_list[i];
					}
				}
			}

			this.transport = [
				{ value: 1, name: 'Aéreo', limite: 500000 },
				{ value: 2, name: 'Marítimo', limite: 500000 },
				{ value: 4, name: 'Terrestre', limite: 500000 },
				{ value: 6, name: 'Ferrocarril', limite: 500000 },
				{ value: 7, name: 'Multimodal', limite: 500000 }
			];
		} else if (param.service_name == 'CHUBB GLOBAL') { // actualizacion para CHUBB GLOBAL
			if (this.quote_selected.rate.cover == 0) {
				for (var i = 0; i < this.cobertura_list.length; i++) {
					if (this.cobertura_list[i].cobertura == 'Mercancía en tránsito') {
						this.quote_cobertura = this.cobertura_list[i];
					}
				}
			}

			this.transport = [
				{ value: 1, name: 'Aéreo', limite: 1200000 },
				{ value: 2, name: 'Marítimo', limite: 1200000 },
				{ value: 4, name: 'Terrestre', limite: 400000 },
				{ value: 6, name: 'Ferrocarril', limite: 400000 },
				{ value: 7, name: 'Multimodal', limite: 400000 }
			];
		} else if (param.service_name == 'CHUBB INTERNACIONAL') { // actualizacion para CHUBB INTERNACIONAL
			if (this.quote_selected.rate.cover == 0) {
				for (var i = 0; i < this.cobertura_list.length; i++) {
					if (this.cobertura_list[i].cobertura == 'Mercancía en tránsito') {
						this.quote_cobertura = this.cobertura_list[i];
					}
				}
			}

			this.transport = [
				{ value: 1, name: 'Aéreo', limite: 3000000 },
				{ value: 2, name: 'Marítimo', limite: 3000000 },
				{ value: 4, name: 'Terrestre', limite: 3000000 },
				{ value: 6, name: 'Ferrocarril', limite: 3000000 },
				{ value: 7, name: 'Multimodal', limite: 3000000 }
			];
		} else if (param.service_name == 'GNP MXN' || param.service_name == 'GNP USD' ||
		           param.service_name == 'CHUBB USD' || param.service_name == 'CHUBB MXN') {
			if(this.quote_selected.rate.cover == 0){
				for(var i = 0; i < this.cobertura_list.length; i ++){
					if(this.cobertura_list[i].cobertura == 'Mercancía en tránsito'){
						this.quote_cobertura = this.cobertura_list[i];
					}
				}
			}

			this.transport = [
				{ value: 1, name: 'Aéreo', limite: 10000000 },
				{ value: 2, name: 'Marítimo', limite: 10000000 },
				{ value: 4, name: 'Terrestre', limite: 10000000 },
				{ value: 6, name: 'Ferrocarril', limite: 10000000 },
				{ value: 7, name: 'Multimodal', limite: 10000000 }
			];
		}

		for(var i = 0; i < this.transport.length; i ++){
			if (typeof this.quote_list.rate.name === 'string') {
				if(this.quote_list.rate.name == this.transport[i].name){
					this.quote_list.rate.name = this.transport[i];
					this.limite_despacho = this.transport[i].limite;
					this.type_transport(this.transport[i]);
				}
			} else {
				if(this.quote_list.rate.name.name == this.transport[i].name){
					this.quote_list.rate.name = this.transport[i];
					this.limite_despacho = this.transport[i].limite;
					this.type_transport(this.transport[i]);
				}
			}
		}

		if (param.service_name == this.enumAseguradora.ChubbUsd && this.quote_list.tipo_mercancia.name == this.enumContenedor.Contenedor) {
			// establecer la descripcion de la mercancia por el nombre del contenedor
			this.quote_selected.descripcion_mercancia = this.contenedorSelect.nombre;
			this.quote_list.descripcion_mercancia = this.contenedorSelect.nombre;
		}
	};

	// Metodo para validar manualmente si la fecha inicio es correcta
	validarFechaInicio() {
		let fechaInicio = this.quote_list.fecha_inicio;
		this.fechaInicioValido = true;

		if (fechaInicio === null) {
			this.fechaInicioValido = false;
			return;
		}

		if (fechaInicio.toString() === 'Invalid Date') {
			this.fechaInicioValido = false;
			return;
		}

		fechaInicio.setHours(0, 0, 0, 0);
		if (fechaInicio.toString() === new Date('12/31/1969').toString()) {
			this.fechaInicioValido = false;
			return;
		}
		return true;
	}

	// Metodo para validar manualmente si la fecha fin es correcta
	validarFechaFin() {
		let fechaFin = this.quote_list.fecha_fin;
		this.fechaFinValido = true;

		if (fechaFin === null) {
			this.fechaFinValido = false;
			return;
		}

		if (fechaFin.toString() === 'Invalid Date') {
			this.fechaFinValido = false;
			return;
		}

		fechaFin.setHours(0, 0, 0, 0);
		if (fechaFin.toString() === new Date('12/31/1969').toString()) {
			this.fechaFinValido = false;
			return;
		}
		return true;
	}

	validarFechaFactura() {
		let fechaFactura = this.quote_list.factura_cargaquote.fecha_factura;
		this.fechaFacturaValido = true;

		if (fechaFactura !== null && fechaFactura !== '') {
			if (fechaFactura.toString() === 'Invalid Date') {
				this.fechaFacturaValido = false;
				return;
			}

			fechaFactura.setHours(0, 0, 0, 0);
			if (fechaFactura.toString() === new Date('12/31/1969').toString()) {
				this.fechaFacturaValido = false;
				return;
			}
		}
		return true;
	}

	validarFechaFacturaPago() {
		let fechaPago = this.quote_list.factura_cargaquote.fecha_pago;
		this.fechaFacturaPagoValido = true;

		if (fechaPago !== null && fechaPago !== '') {
			if (fechaPago.toString() === 'Invalid Date') {
				this.fechaFacturaPagoValido = false;
				return;
			}

			fechaPago.setHours(0, 0, 0, 0);
			if (fechaPago.toString() === new Date('12/31/1969').toString()) {
				this.fechaFacturaPagoValido = false;
				return;
			}
		}
		return true;
	}

	// Sweetalert de error
	alertaError(texto: string, descripcion: string) {
		texto = texto.toLowerCase();
		descripcion = descripcion.charAt(0).toUpperCase() + descripcion.slice(1).toLowerCase();
		swal.fire({
			position: 'top-end',
			html: '<h4 style="color:#F3F3F3">Error en: ' + texto + '</h4>' + '<span style="color:#F3F3F3">' + descripcion + '</span>',
			width: 400,
			padding: '1.5em 0 1em 0',
			background: '#DA5454',
			showConfirmButton: false,
			timer: 3000
		});
	}

	// Sweetalert de exito
	alertaExito(texto: string) {
		texto = texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
		swal.fire({
			position: 'top-end',
			html: '<h4 style="color:#F3F3F3">' + texto + '</h4>',
			width: 400,
			padding: '1.5em 0 1em 0',
			background: '#59DA54',
			showConfirmButton: false,
			timer: 1500
		});
	}

	// Delay para evitar sobrecarga
	delay(ms: number) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	save_edit(param){
	    //console.log("save_edit param",param)
	    //console.log("save_edit quote_list",this.quote_list)
		if(!this.validateLimit2()){
			return;
		}
		if(!this.validateLimite()){
			return;
		}

		if (this.validarFechaInicio() === undefined) {
			this.alertaError('Fecha inicio', 'Fecha inválida, por favor ingresa una fecha correcta');
			return;
		}

		if (this.validarFechaFin() === undefined) {
			this.alertaError('Fecha fin', 'Fecha inválida, por favor ingresa una fecha correcta');
			return;
		}

		if (this.validarFechaFactura() === undefined) {
			this.alertaError('Fecha factura', 'Fecha inválida, por favor ingresa una fecha correcta');
			return;
		}

		if (this.validarFechaFacturaPago() === undefined) {
			this.alertaError('Fecha factura pago', 'Fecha inválida, por favor ingresa una fecha correcta');
			return;
		}

		if (this.quote_list.compania.name!='GNP MXN' && this.quote_list.compania.name!='CHUBB MXN' ){
			param.total_exchange = 2;
		}else {
			param.total_exchange = 1;
		}
		// compania demas
		// fechas formato
		// modo_transporte demas
		// tarifa_asignada demas

		// Actualizar el tipo de mercancia a las dos variables
		param.tipo_mercancia_option = param.tipo_mercancia.name;

		// Establecer la direccion de origen y destino
		// Cambiar logica para que funcione con el nuevo formato de direcciones
		if (param.quote_type === 1) {
			// param.desde.address = param.desde.details.street + " " + param.desde.details.number + ", " + param.desde.details.colony + ", " + param.desde.details.zipcode;
			// param.hasta.address = param.hasta.details.street + " " + param.hasta.details.number + ", " + param.hasta.details.colony + ", " + param.hasta.details.zipcode;
			param.desde.address = null;
			param.hasta.address = null;
		}

		let object = {
			'asegudado': param.asegurado,
			'asegurado_name': param.asegurado_name,
			'aseguradora_name': param.aseguradora_name,
			'buque_viaje_contenedor': param.buque_viaje_contenedor,
			'cobertura_contenedor': param.cobertura_contenedor,
			'cobertura_door_to_door': param.cobertura_door_to_door,
			'contenedores': param.contenedores,
			'contratante': param.contratante,
			'contratante_info': param.contratante_info,
			'compania': param.compania,
			'created_at': param.created_at,
			'date': param.date,
			'descripcion_mercancia': param.descripcion_mercancia,
			'desde': param.desde,
			'do_contenedor': param.do_contenedor,
			'fecha_fin': new Date(param.fecha_fin),
			'fecha_inicio': new Date(param.fecha_inicio),
			'flete': parseFloat(String(param.flete).replace(/,/g, "")),
			'flete_exchange': param.flete_exchange,
			'gastos_adicionales': parseFloat(String(param.gastos_adicionales).replace(/,/g, "")),
			'gastos_operacionales': parseFloat(String(param.gastos_operacionales).replace(/,/g, "")),
			'gastos_operacionales_exchange': param.gastos_operacionales_exchange,
			'gran_total': parseFloat(String(param.gran_total).replace(/,/g, "")),
			'hasta': param.hasta,
			'id': param.id,
			'impuestos_nacionales': parseFloat(String(param.impuestos_nacionales).replace(/,/g, "")),
			'impuestos_nacionales_exchange': param.impuestos_nacionales_exchange,
			'lucro_cesante': parseFloat(String(param.lucro_cesante).replace(/,/g, "")),
			'linea_transportista': param.linea_transportista,
			'medidas_seguridad': param.medidas_seguridad,
			'numero_certificado': param.numero_certificado,
			'numero_contenedor': param.numero_contenedor,
			'numero_cotizacion': param.numero_cotizacion,
			'numero_documento_contenedor': param.numero_documento_contenedor,
			'numero_pedimento_referencia': param.numero_pedimento_referencia,
			'numero_sello': param.numero_sello,
			'observaciones': param.observaciones,
			'operador': param.operador,
			'paid_out': param.paid_out,
			'prima': parseFloat(String(param.prima).replace(/,/g, "")),
			'prima_check': param.prima_check,
			'prima_contenedor': parseFloat(String(param.prima_contenedor).replace(/,/g, "")),
			'prima_contenedor_check': param.prima_contenedor_check,
			'prima_venta': parseFloat(String(param.prima_venta).replace(/,/g, "")),
			'primaeo': parseFloat(String(param.primaeo).replace(/,/g, "")),
			'primaeo_check': param.primaeo_check,
			'rate': param.rate,
			'rc_errores_omisiones': param.rc_errores_omisiones,
			'service': param.service,
			'solicitado_por': param.solicitado_por,
			'status': param.status,
			'subtotal': parseFloat(String(param.subtotal).replace(/,/g, "")),
			'tasa': parseFloat(param.tasa),
			'tarifa_quote': param.tarifa_quote,
			'tipo_cambio_eur': parseFloat(param.tipo_cambio_eur),
			'tipo_cambio_mxn': parseFloat(param.tipo_cambio_mxn),
			'tipo_cambio_usd': parseFloat(param.tipo_cambio_usd),
			'tipo_contenedor': param.tipo_contenedor,
			'tipo_de_trayecto': param.tipo_de_trayecto,
			'tipo_embalaje': param.tipo_embalaje,
			'tipo_embalaje_another_option': param.tipo_embalaje_another_option,
			'tipo_empaque': param.tipo_empaque,
			'tipo_mercancia': param.tipo_mercancia,
			'tipo_mercancia_option': param.tipo_mercancia_option,
			'total': parseFloat(String(param.total).replace(/,/g, "")),
			'total_check': param.total_check,
			'total_exchange': param.total_exchange,
			'updated_at': param.updated_at,
			'url': param.url,
			'valor_mercancia': parseFloat(String(param.valor_mercancia).replace(/,/g, "")),
			'valor_mercancia_exchange': param.valor_mercancia_exchange
		};
		this.quoteEdition.emit(object);

		if(param.factura_cargaquote.monto == ""){
		    param.factura_cargaquote.monto = 0
		}

		if (param.factura_cargaquote.fecha_factura === '') {
			param.factura_cargaquote.fecha_factura = null;
		}

		if (param.factura_cargaquote.fecha_pago === '') {
			param.factura_cargaquote.fecha_pago = null;
		}

		let objectFactura = {
		    'url': param.factura_cargaquote.url,
			'cargaquote_id': param.id,
			'fecha_factura': param.factura_cargaquote.fecha_factura,
            'fecha_pago': param.factura_cargaquote.fecha_pago,
            'monto': param.factura_cargaquote.monto,
            'iva': param.factura_cargaquote.iva,
            'total': param.factura_cargaquote.total,
            'numero': param.factura_cargaquote.numero,
            'pagado': param.factura_cargaquote.pagado,
            'comentario': param.factura_cargaquote.comentario,
		};

        if (this.quote_selected.factura_cargaquote.url === undefined){
            this.facturaCreate.emit(objectFactura);
        }else{
            this.facturaEdit.emit(objectFactura);
        }
        // comision
        let objectComision = {
		    'url': param.comision_cargaquote.url,
			'cargaquote_id': param.id,
			'fecha_pago_asesor_venta': param.comision_cargaquote.fecha_pago_asesor_venta,
            'fecha_pago_cliente': param.comision_cargaquote.fecha_pago_cliente,
            'comentario': param.comision_cargaquote.comentario,
		};

        if (this.quote_selected.comision_cargaquote.url === undefined){
            this.comisionCreate.emit(objectComision);
        }else{
            this.comisionEdit.emit(objectComision);
        }

		// Se solicita delay para evitar sobrecarga
		this.delay(2000).then(() => {
			this.returnToList();
		});

	};

	onFileChange(event, document) {
	    if (event.target.files[0].size > 1 && event.target.files[0].size < 6291456 ){ // 6 MB = 6291456 B 3 MB = 3145728
			var id = document.id
			var file = event.target.files[0];
            var form_data = new FormData();
            form_data.append('id', id);
            form_data.append('document_file', file);
            this.documentFileEdit.emit(form_data);
		}else{
		    alert('El archivo seleccionado solo pueder pesar un maximo de 6MB');
		}
	}

	dobleQuote(){

		this.duplicateQuote.emit();
		localStorage.duplicate = true;
		localStorage.from_list = true;
		//let new_location = 'step_1';

		//this.location = new_location;
		//localStorage.location = new_location;
		// this.edit = true;
		//this.doble = true;
		//this.referancia1 = this.quote_selected.numero_pedimento_referencia;
		//this.referancia2 = this.quote_selected.numero_sello;
		//this.inicioFecha = this.quote_selected.fecha_inicio;
		//this.finFecha = this.quote_selected.fecha_fin;

		//this.editQuote(this.quote_selected);

		//this.quote_list.numero_pedimento_referencia = null;
		//this.quote_list.numero_sello = null;
		//this.quote_list.numero_documento_contenedor = null;
		//this.quote_list.fecha_inicio = null;
		//this.quote_list.fecha_fin = null;
	};

	type_transport(param) {
		this.quote_selected.modo_transporte = param;

		// se agrega GPS + Custodia virtual para HDI
		if(this.quote_selected.compania == 'HDI' || (this.quote_selected.compania.name ? this.quote_selected.compania.name == 'HDI' : false)) {
			this.security_measures = [
				'GPS',
				'GPS + Custodia virtual',
				'GPS + Custodia física',
				'GPS + Custodia física "armada"',
				'Otra'
			];
		} else if (this.quote_selected.compania == 'CHUBB GLOBAL' || (this.quote_selected.compania.name ? this.quote_selected.compania.name == 'CHUBB GLOBAL' : false)) { // actualizacion para CHUBB GLOBAL
			this.security_measures = [
				'GPS',
				'GPS + Custodia virtual',
				'GPS + Custodia física',
				'Otra'
			];
		} else if (this.quote_selected.compania == 'CHUBB INTERNACIONAL' || (this.quote_selected.compania.name ? this.quote_selected.compania.name == 'CHUBB INTERNACIONAL' : false)) { // actualizacion para CHUBB INTERNACIONAL
			this.security_measures = [
				'GPS',
				'GPS + Custodia virtual',
				'GPS + Custodia física',
				'Otra'
			];
		} else {
			if(this.quote_selected.rate.name == 'Terrestre') {
					this.security_measures = [
						'GPS',
						'GPS + Custodia virtual',
						'GPS + Custodia física',
						'Otra'
					];
			} else {
				this.security_measures = [
					'Ninguna',
					'GPS',
					'GPS + Custodia virtual',
					'GPS + Custodia física',
					'Otra'
				];
			}
		}
		for(var i = 0; i < this.security_measures.length; i ++){
			if(this.quote_list.medidas_seguridad == this.security_measures[i]){

				this.quote_list.medidas_seguridad = this.security_measures[i];
			}
		}
	};

	validateLimite(){
		let valid = true;
		if (this.quote_selected.total > this.limite_despacho) {
			//this.quote_selected.valor_mercancia = 0;
			//this.valor_mecancia = 0;
			valid=false;
			alert("El total asegurado no puede superar el límite de despacho.");
			//this.quote_selected.subtotal = (this.valor_mecancia + this.valor_flete + this.valor_impuestos).toFixed(2);
			//this.quote_selected.total = (parseFloat(this.quote_selected.subtotal) + this.valor_operacion).toFixed(2);

			// if (this.quote.currency_total == 'usd') {
			// 	this.quote.subtotal = (this.quote.subtotal / this.rate_exchange_usd).toFixed(2);
			// 	this.quote.total_asegurado = (this.quote.total_asegurado / this.rate_exchange_usd).toFixed(2);
			// }
		}
		return valid;
	}
	validateLimit2(){
		let valid = true;
		if (this.quote_selected.valor_mercancia.length > 2) {
			let min_valor_marcancia = 60;
			if (this.quote_selected.compania == 1 && this.valor_mecancia < min_valor_marcancia) {
				valid =false;
				alert("En JAH la prima mínima de venta debe ser $60dlls.");
			}
		}
		if (this.valor_flete > (this.valor_mecancia * 0.6)) {
			valid =false;
			alert("El flete no puede superar el 60% del valor de la factura.");
		}
		if (this.valor_impuestos > this.valor_mecancia) {
			valid =false;
			alert("El impuesto nacional no puede superar el valor de la factura.");
		}
		if (this.valor_lucro_cesante > (this.valor_mecancia * 0.2)) {
			valid =false;
			alert("El lucro cesante no puede superar el 20% sobre el valor total asegurado.");
		}
		if (this.quote_selected.compania.name != 'JAH') {
			if (this.valor_operacion > (this.valor_mecancia * 0.20)) {
				valid =false;
				alert("Los gastos operacionales no pueden superar el 20% sobre el valor de la factura.");
			}
		} else if (this.quote_selected.compania.name == 'JAH') {
			if (this.valor_operacion > (this.valor_mecancia * 0.1)) {
				valid =false;
				alert("Los gastos operacionales no pueden superar el 10% sobre el valor de la factura.");
			}
		}
		return valid
	}


	calculateSubtotalUltimate() {

		if ((this.gas_add) == 'si') {
			this.quote.gastos_adicionales = true;
		} else {
			this.quote.gastos_adicionales = false;
			$("#g_add").trigger('click');
		}

		this.quote_list.valor_mercancia = this.quote_list.valor_mercancia ? this.quote_list.valor_mercancia : 0;
		this.quote_selected.flete = this.quote_selected.flete ? this.quote_selected.flete : 0;
		this.quote_selected.impuestos_nacionales = this.quote_selected.impuestos_nacionales ? this.quote_selected.impuestos_nacionales : 0;
		this.quote_selected.lucro_cesante = this.quote_selected.lucro_cesante ? this.quote_selected.lucro_cesante : 0;
		this.quote_selected.gastos_operacionales = this.quote_selected.gastos_operacionales ? this.quote_selected.gastos_operacionales : 0;

		this.valor_type = this.quote_selected.valor_mercancia_exchange;
		this.flete_type = this.quote_selected.flete_exchange;
		this.impuestos_type = this.quote_selected.impuestos_nacionales_exchange;
		this.operacion_type = this.quote_selected.gastos_operacionales_exchange;

		this.valor_mecancia = this.convertCurrency(this.quote_selected.valor_mercancia, this.valor_type);

		this.valor_flete = this.convertCurrency(this.quote_selected.flete, this.flete_type);
		this.valor_impuestos = this.convertCurrency(this.quote_selected.impuestos_nacionales, this.impuestos_type);
		this.valor_lucro_cesante = this.convertCurrency(this.quote_selected.lucro_cesante, this.valor_type);
		this.valor_operacion = this.convertCurrency(this.quote_selected.gastos_operacionales, this.operacion_type);
		this.validateLimit2();

		this.quote_list.subtotal = (this.valor_mecancia + this.valor_flete + this.valor_impuestos + this.valor_lucro_cesante).toFixed(2);
		this.quote_selected.total = (parseFloat(this.quote_list.subtotal) + this.valor_operacion).toFixed(2);

		if (this.quote.gastos_adicionales) {
			let _v_mercancia = (this.convertCurrency(this.quote_selected.valor_mercancia, this.valor_type)).toFixed(2);

			if(this.quote_selected.compania.name == 'JAH') {

				let x  = (this.convertCurrency(this.quote.valor_mercancia, this.valor_type)).toFixed(2);
				_v_mercancia =  (parseFloat(x) / this.rate_exchange_usd).toFixed(2);
			}
			this.gastos_adicionales = (parseFloat(_v_mercancia) * 0.1);
			this.quote_selected.total = (parseFloat(this.quote_selected.total) + (this.valor_mecancia * 0.1)).toFixed(2);
		}

		// this.quote.result_total_peso = this.quote.total_asegurado;
		// this.quote.result_total_dollar = (this.quote.total_asegurado / this.rate_exchange_usd).toFixed(2);
		// pesos a dolares
		if (this.quote_selected.valor_mercancia_exchange == 1 && this.quote_selected.total_exchange==2) {
			this.quote_selected.subtotal = (this.quote_list.subtotal / this.rate_exchange_usd).toFixed(2);
			this.quote_selected.total = (this.quote_selected.total / this.rate_exchange_usd).toFixed(2);
		}else if(this.quote_selected.valor_mercancia_exchange == 3 && this.quote_selected.total_exchange==1){
			this.quote_selected.subtotal = this.quote_list.subtotal.toFixed(2);
			this.quote_selected.total = this.quote_selected.total.toFixed(2);
		}else if((this.quote_selected.valor_mercancia_exchange == 3 || this.quote_selected.valor_mercancia_exchange == 2 )&& this.quote_selected.total_exchange==2){
			this.quote_selected.subtotal = (this.quote_list.subtotal/ this.rate_exchange_usd).toFixed(2);
			this.quote_selected.total = (this.quote_selected.total/ this.rate_exchange_usd).toFixed(2);
		}

		//if (this.quote_list.compania.name!='GNP MXN'){
		//	this.quote_selected.subtotal = this.quote_selected.subtotal/ this.rate_exchange_usd;
		//	this.quote_selected.total = this.quote_selected.total/ this.rate_exchange_usd;
		//}
		if(!this.validateLimite()){
			return;
		}


		//this.onAmountChange('subtotal', { 'data': this.quote_selected.subtotal }, null);
		//this.onAmountChange('total', { 'data': this.quote_selected.total }, null);
		//this.onAmountChange('valor_mercancia', { 'data': this.quote.prima }, null);
		//this.onAmountChange('flete', { 'data': this.quote.flete }, null);
		//this.onAmountChange('impuestos_nacionales', { 'data': this.quote.impuestos_nacionales }, null);
		//this.onAmountChange('gastos_operacionales', { 'data': this.quote.gastos_operacionales }, null);
		//this.onAmountChange('prima', { 'data': this.quote.prima }, null);
		//this.onAmountChange('gran_total', { 'data': this.quote.gran_total }, null);

		this.changeTotalPrima();
	};

	calculateIvaTotalFactura(){
	    if (this.quote_selected.factura_cargaquote.monto > 0){
	        let monto = this.quote_selected.factura_cargaquote.monto;
	        let iva = monto * 0.16;

	        //parseFloat(String(param.gran_total).replace(/,/g, "")),
	        this.quote_selected.factura_cargaquote.iva = Number(iva).toFixed(2);
	        this.quote_selected.factura_cargaquote.total = (Number(monto)+Number(iva)).toFixed(2);
	    }else{
            this.quote_selected.factura_cargaquote.iva = 0;
            this.quote_selected.factura_cargaquote.total = 0;
	    }
	};

	convertCurrency(value, currency) {
		let value_int = String(value).replace(/,/g, "");
		let valor = 0;
		if (currency == 'mxn' || currency == 1) {
			valor = parseFloat(value_int) * this.rate_exchange_mxn;
		} else if (currency == 'usd' || currency == 2) {
			valor = parseFloat(value_int) * this.rate_exchange_usd;
		} else if (currency == 'eur' || currency == 3) {
			valor = parseFloat(value_int) * this.rate_exchange_eur;
		}
		return valor;
	};

	changeTasaVenta(){
		if(this.quote_list.tasa.length == 3){
			this.quote_list.tasa = this.quote_list.tasa + '0';
		}
		this.changeTotalPrima();
	};

	changeTotalPrima() {
		this.percent_value_ = true;
		let tasa_prima;
		let tasa_prima___ = (this.quote_list.tasa.toString()).replace('%', '');
		let tipoMercancia = this.quote_list.tipo_mercancia.name;

		if (this.percent_value_) {
			// this.quote.tasa_prima = this.quote.tasa_prima / 100;
			if (tipoMercancia == this.enumContenedor.Contenedor) {
				tasa_prima = tasa_prima___ / 10000; // si es contenedor se divide entre 10000 para obtener el valor correcto de la tasa
			} else {
				tasa_prima = tasa_prima___ / 100;
			}
		} else {
			// this.quote.tasa_prima = this.quote.cobertura.tarifa;
			tasa_prima = tasa_prima___;
		}

		tasa_prima = tasa_prima ? tasa_prima : parseFloat(String(this.quote_selected.cobertura.value).replace(/%/g, ""));
		tasa_prima = tasa_prima ? tasa_prima : 0.2;

		// omitir si es tipo contenedor
		if (tipoMercancia != this.enumContenedor.Contenedor) {
			if (this.quote_list.tasa.length >= 4) {
				for(var i = 0; i < this.cobertura_list.length; i++){
					if(this.cobertura_list[i].cobertura == this.quote_cobertura.cobertura){
						if (parseFloat(this.quote_list.tasa) < parseFloat(this.cobertura_list[i].tarifa)) {
							this.quote_list.tasa = parseFloat(String(this.cobertura_list[i].tarifa).replace(/%/g, ""));
							tasa_prima = this.quote_list.tasa / 100;
							alert("No puede ser menor a " + this.cobertura_list[i].tarifa);
						}
					}
				}
			}
			if (this.quote_selected.tasa >= 1) {
				this.quote_selected.tasa = 0.99;
				alert("No puede ser mayor a 0.99");
			}
		}

		this.quote_list.prima = (parseFloat(String(this.quote_list.total).replace(/,/g, "")) * parseFloat(tasa_prima)).toFixed(2);

		this.quote_list.prima_contenedor = this.quote_list.prima_contenedor ? this.quote_list.prima_contenedor : 0;
		this.quote_list.prima_contenedor = parseFloat(this.quote_list.prima_contenedor).toFixed(2);

		if (this.quote_list.rc_errores_omisiones) {
			if (parseInt(String(this.quote_list.valor_mercancia).replace(/,/g, "")) <= 10000) {
				this.quote_list.primaeo = 10;
			} else if (parseInt(String(this.quote_list.valor_mercancia).replace(/,/g, "")) > 10000 && parseInt(String(this.quote_selected.valor_mercancia).replace(/,/g, "")) <= 50000) {
				this.quote_list.primaeo = 25;
			} else if (parseInt(String(this.quote_list.valor_mercancia).replace(/,/g, "")) > 50000) {
				this.quote_list.primaeo = 35;
			}
		} else {
			this.quote_selected.primaeo = 0;
		}
		// if (this.quote_selected.currency_total == 'usd') {
			// this.quote_selected.primaeo = (parseFloat(this.quote_selected.primaeo)).toFixed(2);
		// } else {
		// 	this.quote_selected.primaeo = (this.quote_selected.primaeo * this.rate_exchange_usd).toFixed(2);
		// }

		this.quote_list.gran_total = (parseFloat(this.quote_list.prima) + parseFloat(this.quote_list.primaeo) + parseFloat(this.quote_list.prima_contenedor)).toFixed(2);

		if (tipoMercancia == this.enumContenedor.Contenedor) {
			// realizar comprobacion con base a la prima minima del contenedor seleccionado
			if (parseFloat(this.quote_list.prima) < this.contenedorSelect.primaMinima || parseFloat(this.quote_list.gran_total) < this.contenedorSelect.primaMinima) {
				this.quote_list.prima = this.contenedorSelect.primaMinima.toFixed(2);
				this.quote_list.gran_total = this.contenedorSelect.primaMinima.toFixed(2);

				this.generarTasaVenta();
			}
		}

		// if(this.servicesId == 17 && this.quote.total_prima < 60){
		// 	this.quote.total_prima = 60;
		// 	this.prima_minima = true;
		// }else if(this.servicesId == 11 && this.quote.total_prima < 500){
		// 	this.quote.total_prima = 500;
		// 	this.prima_minima = true;
		// }else if(this.servicesId == 9 && this.quote.total_prima < 500){
		// 	this.quote.total_prima = 500;
		// 	this.prima_minima = true;
		// }else{
		// 	this.prima_minima = false;
		// }

		// this.quote.result_gran_total_peso = this.quote.total_prima / this.rate_exchange_usd;
		// this.quote.result_gran_total_peso = parseFloat(this.quote.result_gran_total_peso).toFixed(2);
		// this.quote.result_gran_total_dollar = this.quote.total_prima * this.rate_exchange_usd;
		// this.quote.result_gran_total_dollar = parseFloat(this.quote.result_gran_total_dollar).toFixed(2);

		//this.onAmountChange('prima', { 'data': this.quote_list.prima }, null);
		//this.onAmountChange('gran_total', { 'data': this.quote_list.gran_total }, null);
		// this.onAmountChange('result_gran_total_peso', { 'data': this.quote.result_gran_total_peso }, null);
		// this.onAmountChange('result_gran_total_dollar', { 'data': this.quote.result_gran_total_dollar }, null);
	};

	calcularPrimaNeta() {
		let input = this.quote_list.prima;

		// remover caracteres no numericos excepto punto
		let valorSanitizado = input.replace(/[^0-9.]/g, '');

		// validar por multiples puntos y remover los extras
		if (valorSanitizado.split('.').length > 2) {
			const partes = valorSanitizado.split('.');
			valorSanitizado = partes[0] + '.' + partes.slice(1).join('');
		}

		// parsear el valor sanitizado a float (o a 0)
		valorSanitizado = parseFloat(valorSanitizado);

		// si prima venta no es un numero o esta vacio se asigna 0 como string
		if (isNaN(valorSanitizado) || valorSanitizado == '') {
			valorSanitizado = '0';
		}

		this.quote_list.prima = valorSanitizado.toString();
		this.quote_list.gran_total = valorSanitizado.toString();
	}

	aplicarDecimales() {
		let input = this.quote_list.prima;
		let inputTotalPrimas = this.quote_list.gran_total;

		// si prima venta no es un numero o esta vacio se asigna 0 como string
		if (isNaN(input) || input == '') {
			input = '0';
		}

		// si prima venta total no es un numero o esta vacio se asigna 0 como string
		if (isNaN(inputTotalPrimas) || inputTotalPrimas == '') {
			inputTotalPrimas = '0';
		}

		// redondear a 2 decimales prima venta
		input = parseFloat(input).toFixed(2);
		this.quote_list.prima = input;

		// redondear a 2 decimales prima venta total
		inputTotalPrimas = parseFloat(inputTotalPrimas).toFixed(2);
		this.quote_list.gran_total = inputTotalPrimas;

		// realizar la validacion con base a la prima minima del contenedor seleccionado
		// si los valores de prima venta y prima venta total son menor a la prima minima del contenedor seleccionado se asigna la prima minima
		if (input < this.contenedorSelect.primaMinima || inputTotalPrimas < this.contenedorSelect.primaMinima) {
			alert('El valor de la prima no puede ser menor a $ ' + this.contenedorSelect.primaMinima.toFixed(2) + ' USD');
			this.quote_list.prima = this.contenedorSelect.primaMinima.toFixed(2);
			this.quote_list.gran_total = this.contenedorSelect.primaMinima.toFixed(2);
		}

		this.generarTasaVenta();

	}

	generarTasaVenta() {
		let primaNeta = parseFloat(this.quote_list.prima);
		let valorMercancia = parseFloat(this.quote_list.total.replace(/,/g, '')); // si es tipo contenedor el valor es el mismo del monto asegurado
		let tasaVenta = (primaNeta / valorMercancia) * 10000; // tasa_venta = (prima / monto_asegurado) * 10000

		// redondear a 2 decimales tasa venta
		tasaVenta = parseFloat(tasaVenta.toFixed(2));

		this.quote_list.tasa = tasaVenta.toString();
	}

	addContainer() {
		this.showModalContainer = true;
		this.value_disabled = false;
		let contenedores = JSON.parse(JSON.stringify(this.quote_selected.contenedores))
		for(var i = 0; i < this._containers_list.length; i++){
			if(this._containers_list[i].serie != undefined){
				this._containers_list[i].serie = "";
			}
		}
		this.quote_selected.contenedores = contenedores;
	};

	validateUntilDate(param) {
		this.quote.importacion_hasta = null;
		if(this.quote_selected){
			this.endMinDate = new Date(this.quote_selected.fecha_inicio);
			this.endMaxDate = new Date();
			this.endMaxDate.setDate(this.endMinDate.getDate() + 120);

		}
	};

	save_doble(param){
		let certificate = {
			'contratante': param.contratante,
			'asegurado': param.asegurado,
			'compania': param.compania,
			'numero_contenedor': param.numero_contenedor,
			'numero_pedimento_referencia': param.numero_pedimento_referencia,
			'numero_sello': param.numero_sello,
			'tipo_mercancia_option': param.tipo_mercancia_option,
			'prima_venta': parseFloat(param.prima_venta),
			'descripcion_mercancia': param.descripcion_mercancia,
			'linea_transportista': param.linea_transportista,
			'numero_documento_contenedor': param.numero_documento_contenedor,
			'buque_viaje_contenedor': param.buque_viaje_contenedor,
			'do_contenedor': param.do_contenedor,
			'operador': param.operador,
			'tipo_embalaje': param.tipo_embalaje,
			'tipo_embalaje_another_option': param.tipo_embalaje_another_option,
			'tipo_empaque': param.tipo_empaque,
			'medidas_seguridad': param.medidas_seguridad,
			'transporte_nacional': false,
			'importacion': false,
			'exportacion': false,
			'fecha_inicio': new Date(param.fecha_inicio),
			'fecha_fin': new Date(param.fecha_fin),
			// 'cobertura_door_to_door': this.quote.trayecto == 1 ? 'Door to Door' : this.quote.trayecto == 2 ? 'Door to Port' : this.quote.trayecto == 3 ? 'Port to Port' : 'Port to Door',
			'cobertura_door_to_door': param.cobertura_door_to_door,
			'tipo_cambio_mxn': parseFloat((this.rate_exchange_mxn).toFixed(2)),
			'tipo_cambio_usd': parseFloat((this.rate_exchange_usd).toFixed(2)),
			'tipo_cambio_eur': parseFloat((this.rate_exchange_eur).toFixed(2)),
			'tipo_de_trayecto'  : param.tipo_de_trayecto,
			'valor_mercancia': parseFloat(String(param.valor_mercancia).replace(/,/g, "")),
			'valor_mercancia_exchange': param.valor_mercancia_exchange,
			'flete': parseFloat(String(param.flete).replace(/,/g, "")),
			'flete_exchange': param.flete_exchange,
			'impuestos_nacionales': parseFloat(String(param.impuestos_nacionales).replace(/,/g, "")),
			'impuestos_nacionales_exchange': param.impuestos_nacionales_exchange,
			'lucro_cesante': parseFloat(String(param.lucro_cesante).replace(/,/g, "")),
			'subtotal': parseFloat(String(param.subtotal).replace(/,/g, "")),
			'gastos_operacionales': parseFloat(param.gastos_operacionales),
			'gastos_operacionales_exchange': param.gastos_operacionales_exchange,
			// 'gastos_adicionales': (parseFloat(String(this.quote.valor_mercancia).replace( /,/g, "")) * 0.1).toFixed(2),
			'gastos_adicionales': param.gastos_adicionales,
			'total': parseFloat(String(param.total).replace(/,/g, "")),
			'total_exchange': param.total_exchange,
			'cobertura_contenedor': param.cobertura_contenedor,
			'rc_errores_omisiones': param.rc_errores_omisiones,
			'tasa': parseFloat(param.tasa),
			'prima': parseFloat(param.prima),
			'primaEO': parseFloat(param.primaeo),
			'primaeo': parseFloat(param.primaeo),
			'prima_contenedor': parseFloat(param.prima_contenedor),
			'gran_total': parseFloat(param.gran_total),
			'prima_check': param.prima_check,
			'primaEO_check': false,
			'primaeo_check': false,
			'prima_contenedor_check': param.prima_contenedor_check,
			'total_check': param.total_check,
			'observaciones': param.observaciones,
			'desde': param.desde,
			'hasta': param.hasta,
			'tipo_mercancia': param.tipo_mercancia,
			'tipo_contenedor': param.tipo_contenedor,
			'contenedores': param.contenedores,
			'rate': param.rate,
			'quote_type': param.quote_type

		};
		this.quoteDoble.emit(certificate);
		this.returnToList();
	};

	cancel(reload=false){
	    //console.log("reload",reload);
	    //console.log("quote_back",localStorage['quote_back']);
		if (reload){
			this.quote_selected = JSON.parse(localStorage['quote_back']);
			if (this.quote_selected.tipo_mercancia.name === this.enumContenedor.Contenedor) { this.validarContenedorActual(); }
			if (this.quote_selected.factura_cargaquote.monto === 0){
                this.quote_selected.factura_cargaquote.fecha_factura = ""
                this.quote_selected.factura_cargaquote.fecha_pago = ""
			}
		}
		this.edit = false;
  		this.doble = false;
  		this.edit_document = false;

  // 		this.quote_list.numero_pedimento_referencia = this.referancia1;
		// this.quote_list.numero_sello = this.referancia2;
		// this.quote_list.fecha_inicio = this.inicioFecha;
		// this.quote_list.fecha_fin = this.finFecha;
	}

	cancelDoble(){
		this.edit = false;
  		this.doble = false;
  		this.edit_document = false;

  		this.quote_list.numero_pedimento_referencia = this.referancia1;
		this.quote_list.numero_sello = this.referancia2;
		this.quote_list.fecha_inicio = this.inicioFecha;
		this.quote_list.fecha_fin = this.finFecha;
	}

	show_pdf(){
		// si es jah y es certificado
		if(this.quote_selected.asegurado_name == 'JAH' && this.quote_selected.status == 3) {
			if(this.quote_selected.response_jah.result.message == 'Success') {
				window.open(this.quote_selected['response_jah']['result']['path'], '_blank');
			}
		} else {
			// generar el certificado u hoja de trabajo del sistema
			this.sendPdfData.emit(this.quote_selected);
		}
	}

	selectLoad(param) {

		for(let i in this.quote_selected.carga_quote_contratate) {

			let item = this.quote_selected.carga_quote_contratate[i];

			if(param.id == item.id) {
				param.selected = true;
				this.load_selected = item;
			} else {
				item.selected = false;
			}
		}
	};

   	onInputChange(event, param) {

	    var newVal = event.replace(/\D/g, '');

	    var rawValue = newVal;
	    // if(backspace) {
	    //   newVal = newVal.substring(0, newVal.length - 1);
	    // }

	    if(newVal.length == 0) {
	      newVal = '';
	    }
	    else if(newVal.length <= 2) {
	      newVal = newVal.replace(/^(\d{0,2})/, '$1');
	    } else if(newVal.length <= 4) {
	      newVal = newVal.replace(/^(\d{0,2})(\d{0,2})/, '$1/$2');
	    } else {
	      newVal = newVal.replace(/^(\d{0,2})(\d{0,2})(\d{0,4})/, '$1/$2/$3');
	    }

   		this.quote[param] = newVal;
	};

	checkValue(event) {
  		// console.log('event', event);
  		if((event.code).search('Digit') > -1 ||
  			(event.code).search('Numpad') > -1 ||
  			event.code == 'Backspace' ||
  			event.code == 'Delete' ||
  			event.code == 'ArrowLeft' ||
  			event.code == 'Tab' ||
  			event.code == 'ArrowRight') {
  			return true;
  		} else {
  			return false;
  		}
  	};

  	// Filtrar por status
  	getQuotesByStatus(param) {

  		for(let i in param) {
  			let item = param[i];
  			if(!param[i] || param[i] == "")  {
  				param[i] = 0;
  			}

  			if(i == "is_admin"){
  				param[i] = this.admin;
  			}

  			if(i == "collapsable" && param[i] == 0){
  				param[i] = false;
  			}

			if (i == "usuario" && param[i] == 0) {
				param[i] = '';
			}

  		}

  		this.paramsQuotes.emit(param);

  	};

  	searchQuotes(param) {
  		this.specificQuote.emit(param);
  	};

	// Colocando fechas validas
	setFechasValidas() {
		this.fechaInicioValido = true;
		this.fechaFinValido = true;
		this.fechaFacturaValido = true;
		this.fechaFacturaPagoValido = true;
	}


  	returnToList() {
		// Restableciendo valores del paginador
		this.actual_page = 1;
		this.selectedIndex = 0;
		this.start = 0;
		this.end = 5;

		// Colocando bandera de fechas a validas
		this.setFechasValidas();

		this.getQuotesByStatus(this.search_params);
  		this.load_selected = null;
  		this.quote_selected = null;

  		this.cancel()
   	};

  	clearQuote() {
  		this.quote = {
			tipo_mercancia: null,
			compania: null,
			descripcion_mercancia: null,
			tipo_embalaje: null,
			cobertura_contenedor: false,
			tipo_contenedor: null,
			medidas_seguridad: null,
			numero_pedimento_referencia: null,
			numero_sello: null,
			numero_contenedor: null,
			rc_errores_omisiones: false,
			valor_mercancia: null,
			flete: null,
	        impuestos_nacionales: null,
			lucro_cesante: 0,
	        subtotal: null,
	        gastos_adicionales: null,
	        total: null,
	        tipo_cambio_eur: this.valores_moneda.euro,
	        tipo_cambio_mxn: this.valores_moneda.mxn,
	        tipo_cambio_usd: this.valores_moneda.usd,
	        prima_venta: null,
	        linea_transportista: null,
	        transporte_nacional: false,
	        importacion: false,
	        exportacion: false,
	        operador: null,
	        importacion_desde: '',
	        importacion_hasta: '',
	        exportacion_desde: '',
	        exportacion_hasta: '',
	        observaciones: null,
	        solicitado_por: null,
	        valor_mercancia_exchange: null,
	        flete_exchange: null,
	        impuestos_nacionales_exchange: null
		};
  	}

  	primaVentaChange(param) {
  		// console.log('param', param);
  		let prima = parseFloat(this.quote.prima_venta);
  		// console.log(prima)
  		if( prima >= 1) {


  			// this.quote.prima_venta = null;
  			this.quote.prima_venta = 1;
  		}

  	}

  	changeForm(param) {

  		if(param == 1) {

  			this.addContractor.emit(this.data);
  			this.changeStep(1);

  		} else if(param == 2) {

  			this.changeStep(3);
  			this.quote['contratante'] = this.contractor_selected.id;
  			localStorage['quote_1'] = JSON.stringify(this.quote);
  			this.quote_1 = this.quote;
  			this.calculateSubtotal(1,1);
  			this.calculateSubtotal(2,1);
  			this.calculateSubtotal(3,1);

  		} else if(param == 3) {

  			localStorage['quote_2'] = JSON.stringify(this.quote);
  			this.quote_1 = null;
  			this.quote_2 = this.quote;
  			this.changeStep(4);

  		} else if(param == 4) {

  			  	// SAVE QUOTE
  			// localStorage['quote_3'] = JSON.stringify(this.quote);
  			// this.quote_3 = this.quote;

  			if(!this.quote.contratante) {

  				this.quote.contratante = this.contractor_selected.id;
  			}

  			this.quote.gastos_adicionales = this.gastos_adicionales;

  			this.quote.solicitado_por = this.user_info.first_name + ' ' + this.user_info.last_name;

  			this.quote.valor_mercancia = (this.quote.valor_mercancia).replace(/,/g, '');

  			if( this.quote.flete) {
  				this.quote.flete = (this.quote.flete).replace(/,/g, '');
  			} else {
  				this.quote.flete = 0;
  			}

  			if(this.quote.impuestos_nacionales) {
  				this.quote.impuestos_nacionales = (this.quote.impuestos_nacionales).replace(/,/g, '');
  			} else {
  				this.quote.impuestos_nacionales = 0;
  			}

			if (this.quote.lucro_cesante) {
				this.quote.lucro_cesante = (this.quote.lucro_cesante).replace(/,/g, '');
			} else {
				this.quote.lucro_cesante = 0;
			}

  			// this.quote.prima_venta = (this.quote.prima_venta).replace(/,/g, '');

  			this.quote.valor_mercancia = parseFloat(this.quote.valor_mercancia);
  			this.quote.prima_venta = parseFloat(this.quote.prima_venta);
  			this.quote.subtotal = parseFloat(this.quote.subtotal);
  			this.quote.total = parseFloat(this.quote.total);
  			this.quote.flete = parseFloat(this.quote.flete);


  			if(!this.quote.transporte_nacional) {
  				this.quote.transporte_nacional = false;
  			}


  			if(this.quote.rc_errores_omisiones == null || this.quote.rc_errores_omisiones == undefined) {
  				this.quote.rc_errores_omisiones = false;
  			}

  			if(this.quote.importacion) {
	  			this.quote.importacion_desde = this.parseDate(this.quote.importacion_desde);
	  			this.quote.importacion_hasta = this.parseDate(this.quote.importacion_hasta);
  			} else {
  				this.quote.importacion_desde = null;
  				this.quote.importacion_hasta = null;
  			}

  			if(this.quote.exportacion) {
	  			this.quote.exportacion_desde = this.parseDate(this.quote.exportacion_desde);
	  			this.quote.exportacion_hasta = this.parseDate(this.quote.exportacion_hasta);
  			} else {
  				this.quote.exportacion_desde = null;
  				this.quote.exportacion_hasta = null;
  			}

  			if(!this.quote.valor_mercancia_exchange) {
  				this.quote.valor_mercancia_exchange = 1;
  			}

  			if(!this.quote.flete_exchange) {
  				this.quote.flete_exchange = 1;
  			}

  			if(!this.quote.impuestos_nacionales_exchange) {
  				this.quote.impuestos_nacionales_exchange = 1;
  			}

  			this.quote.status = 1;

  			this.saveQuote.emit(this.quote);
  			// LIMPIAR QUOTE

  		}
  	};

  	changeCompany(item){
  		if(item == 1){
  			this.badge = 1;
  			this.currency = "USD";
  		}
  		else{
  			this.badge = 19.44;
  			this.currency = "MXN";
  		}
		this.aseguradoraActual = this.quote_list.compania.name;
		this.calculateSubtotalUltimate()
		let data = {
			grupo: this.quote_list.contratante,
			service: item.id
		}
  		this.getCommonCom.emit(data);
  	};

	aplicarValorMercancia() {
	// establecer el valor de la mercancia del contenedor en la variable de quote.valor_mercancia
	this.quote_selected.valor_mercancia = this.contenedorSelect.monto;


	this.calculateSubtotalUltimate(); // calcular el subtotal y el total
	}

  	cancelContainer(){
  		this.showModalContainer = false;
  		this.container = [];
  	}

  	closeContainer(){
  		this.showModalContainer = false;
		if (this.quote_selected.rate.cover == 3) {
			for (var i = 0; i < this.quote_selected.contenedores.length; ++i) {
				if (this.quote_selected.contenedores[i].container == 1 || this.quote_selected.contenedores[i].container == 2 || this.quote_selected.contenedores[i].container == 3) {
					this.free_container = true;
					this.free = this.quote_selected.contenedores[i];
					break;
				}
			}
		}

		if (this.free_container) {
			this.quote_selected.prima_contenedor = parseFloat(this.quote_selected.prima_contenedor) - parseFloat(this.free['premium']['1']);
		}
		this.container = [];
  	};

  	changeTypeContainer(item){
  		// this.container.name = item.name;
  		// this.container.value = '$' + (item.value * this.badge) + ' ' + this.currency;
  		// this.container.prima = '$' + (item.prima * this.badge) + ' ' + this.currency;
  		this.value_disabled = true;
  	};

  	deleteContainer(idx, item){
		this.quote_selected.contenedores.splice(idx, 1);
		this.quote_selected.prima_contenedor = 0;
		if (this.free) {
			if (item.serie == this.free['serie']) {
				this.free_container = false;
				this.free = [];
			}
		}

		for (var i = 0; i < this.quote_selected.contenedores.length; ++i) {
			this.quote_selected.prima_contenedor = parseFloat(this.quote_selected.prima_contenedor) + parseFloat(this.quote_selected.contenedores[i].premium['1']);
		}
		if (this.quote_selected.rate.cover == 3) {
			for (var i = 0; i < this.quote_selected.contenedores.length; ++i) {
				if (this.quote_selected.contenedores[i].container == 1 || this.quote_selected.contenedores[i].container == 2 || this.quote_selected.contenedores[i].container == 3) {
					this.free_container = true;
					this.free = this.quote_selected.contenedores[i];
					break;
				}
			}
		}
		if (this.free_container) {
			this.quote_selected.prima_contenedor = parseFloat(this.quote_selected.prima_contenedor) - parseFloat(this.free['premium']['1']);
		}

{

}		this.changeTotalPrima();
		this.container = [];
  	};

  	saveContainer(){
  		const copy = this.container;
  		this.quote_selected.contenedores.push(copy);

  		this.quote_selected.prima_contenedor = 0;

		for (var i = 0; i < this.quote_selected.contenedores.length; ++i) {
			this.quote_selected.prima_contenedor = parseFloat(this.quote_selected.prima_contenedor) + parseFloat(this.quote_selected.contenedores[i].premium['1']);
		}
		// if (this.free_container) {
		// 	this.quote_selected.prima_contenedor = parseFloat(this.quote_selected.prima_contenedor) - parseFloat(this.free['premium']['1']);
		// }

		this.changeTotalPrima();
		this.closeContainer();
		// this.container.serie = "";
		this.container = [];
  	};

  	parseDate(parDate) {

  		let date = parDate.split('/');
  		let format_date = new Date(date[2], date[1], date[0]);

  		return format_date;
  	};

  	onAmountChange(param, event, backspace) {

		// console.log('parValue', param);
		// console.log('evetn', event);

		let characterInput  = event.data;
		// let characterInput  = event;

		// let value = String(this.data.valor_carga);
		let value = String(this.quote_list[param]);
		// let value = String(event);

		value = value.replace( /,/g, "" )
		value = value.replace( /[a-zA-Z]/g, "" )

		let first_value;
		let decimals;
		let newVal;

		let data = value.split('.');

		// console.log(data.length);
		if(data.length == 2) {
			first_value = data[0];
			decimals = data[1];
		} else {
			first_value = data[0];
			decimals = '';

		}

		if(first_value.length < 4) {
	      first_value = first_value.replace(/^(\d{0,3})/, '$1');
	    } else if(first_value.length == 4) {
	      first_value = first_value.replace(/^(\d{0,1})(\d{0,3})/, '$1,$2');
	    } else if(first_value.length == 5) {
	      first_value = first_value.replace(/^(\d{0,2})(\d{0,3})/, '$1,$2');
	    } else if(first_value.length == 6) {
	      first_value = first_value.replace(/^(\d{0,3})(\d{0,3})/, '$1,$2');
	    } else if(first_value.length == 7) {
	      first_value = first_value.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})/, '$1,$2,$3');
	    }else if(first_value.length == 8) {
	      first_value = first_value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})/, '$1,$2,$3');
	    }else if(first_value.length == 9) {
	      first_value = first_value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3');
	    }else if(first_value.length == 10) {
	      first_value = first_value.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4');
	    }else if(first_value.length == 11) {
	      first_value = first_value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4');
	    }else if(first_value.length == 12) {
	      first_value = first_value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4');
	    }else if(first_value.length == 13) {
	      first_value = first_value.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
	    }else if(first_value.length == 14) {
	      first_value = first_value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
	    }else if(first_value.length == 15) {
	      first_value = first_value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
	    }else if(first_value.length == 16) {
	      first_value = first_value.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
	    }else if(first_value.length == 17) {
	      first_value = first_value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
	    	// exeded = true;
	    	// newVal = first_value + '.00';
	    	// this.data.valor_carga = first_value;
	    	// return;
	    }else if(first_value.length == 18) {
	      first_value = first_value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
	    	// exeded = true;
	    	// newVal = first_value + '.00';
	    	// this.data.valor_carga = first_value;
	    	// return;
	    }

	 	if(decimals !== '') {
	   		newVal = first_value + '.'+ decimals;
	 	} else {
	 		newVal = first_value;
	 	}


	   	// console.log('-------------');
	   	this.quote_list[param] = newVal;
	   	// return
  	};

  	calculateSubtotal(parAttr, parVal) {

  		let subtotal = 0;
  		let valor_mecancia  = (this.quote.valor_mercancia).replace( /,/g, "" );
  		let flete = 0;
  		let impuestos = 0;
		let lucro_cesante = 0;

  		if(this.quote.flete) {
  			flete 			= (this.quote.flete).replace( /,/g, "" );
  		}

  		if(this.quote.impuestos_nacionales) {
  			impuestos		= (this.quote.impuestos_nacionales).replace( /,/g, "" );
  		}

		if (this.quote.lucro_cesante) {
			lucro_cesante = (this.quote.lucro_cesante).replace(/,/g, "");
		}

  		let valor_ = valor_mecancia ? valor_mecancia : 0;
  		let valor_cambio = this.quote.valor_type ? this.quote.valor_type : 1;
  		valor_ = valor_ * valor_cambio;

  		let flete_ = flete ? flete : 0;
  		let flete_cambio = this.quote.flete_type ? this.quote.flete_type : 1;
  		flete_ = flete_ * flete_cambio;

  		let impuestos_ = impuestos ? impuestos : 0;
  		let impuestos_cambio = this.quote.impuestos_type ? this.quote.impuestos_type : 1;
  		impuestos_ = impuestos_ * impuestos_cambio;

		let lucro_cesante_ = lucro_cesante ? lucro_cesante : 0;
		let lucro_cesante_cambio = this.quote.valor_type ? this.quote.valor_type : 1;
		lucro_cesante_ = lucro_cesante_ * lucro_cesante_cambio;

  		let subtotal_pesos = (valor_) + (flete_) + (impuestos_) + (lucro_cesante_);
  		let subtotal_dolars = parseFloat(subtotal_pesos) / this.valores_moneda.usd;

  		if(this.quote.compania == 1) {
  			subtotal = subtotal_dolars;

  		} else {
  			subtotal = subtotal_pesos;
  		}

  		if(parAttr == 1) {
  			this.quote.valor_mercancia_exchange = parVal;
  		} else if(parAttr == 2) {
  			this.quote.flete_exchange = parVal;
  		} else if(parAttr == 3) {
  			this.quote.impuestos_nacionales_exchange = parVal;
  		}


  		this.quote.subtotal = (subtotal).toFixed(2);

  		if(this.quote.gastos_adicionales) {
 			this.gastos_adicionales = subtotal * 0.10;
 			this.gastos_adicionales = parseFloat(this.gastos_adicionales).toFixed(2);

  			this.quote.total = subtotal * 1.10;
  			this.quote.total = (this.quote.total).toFixed(2);

  		} else {
  			this.gastos_adicionales = 0;
  			this.quote.total = (subtotal).toFixed(2);
  			this.quote.total = parseFloat(this.quote.total).toFixed(2);
  		}
  	};

  	checkDates(quote){
  		let fecha_i = new Date(quote.fecha_inicio)
  		let aux_date = new Date();

  		if(fecha_i.setHours(0,0,0,0) < aux_date.setHours(0,0,0,0)){
  			this.show_dates_em = true;
  		} else {
  			this.show_dates_em = false;
  		}


  	}
  	emition_process = false;
  	emitirCertificateJah(user, params) {

		// this.categories.certificado = false;
		// console.log('compañia', this.quote.compania);

		this.emition_process = true;

		let data = {
			id: params.id,
			// insurance: 'jah'
			insurance : params.aseguradora_name,
			insuranceId : params.aseguradora_name,
			facturacion : params.facturacion ? params.facturacion : 0,
		};

		// aquí dimiss modal
		// $('#modalContact').modal('hide');
		// console.log('data', data);
		//
		this.emitirQuotes.emit(data);
	}

  	emitirCertificateHDI(user, params) {
		let data = {
			id: params.id,
			insurance : params.aseguradora_name,
			es_detalle: true,
			params: {
				service : params.aseguradora_name,
				carga_quote: params.id,
				email: user.email,
				phone: user.telefono ? params.telefono : "",
				facturacion : params.facturacion ? params.facturacion : 0,
				startDate: new Date(params.fecha_inicio),
				endDate: new Date(params.fecha_fin)
			}
		};
		this.emitirQuotes.emit(data);
		// Enviar a la lista de cotizaciones
		this.delay(2000).then(() => {
			this.returnToList();
		});
	}

  	changeStatus(param) {

  		let data =  {
  			url: this.load_selected.url,
  			params: {
  				status : param
  			}
  		};

  		this.saveStatus.emit(data);
  	};

  	start = 0;
  	actual_page = 1;
  	end = 5;
  	not_next;
  	show_prev_block = false;
  	status_quote;
  	not_prev;

	selectedIndex: number = null;

	setIndex(index: number) {
		this.selectedIndex = index;
	}

	removeClass() {
		this.selectedIndex = null;
	}

  	previousBlockPages(params) {
		if(params) {
			if(this.start < this.actual_page) {
				this.start = this.start - 1 ;
                this.end = this.end - 1;
			}
		} else {
          this.start = this.start - 5 ;
          this.end = this.end - 5;

          if(this.end < this.totalPages.length) {
              this.not_next = false;
          }
        }

        if(this.end <= 5) {
          	this.start = 0;
          	this.end = 5;
          	this.show_prev_block = false;
        }
	};

	selectPage(parPage) {

		var params_uri = '';
		let url = '';
		for(let i in this.search_params) {

			let item = this.search_params[i];

			if(item) {

				if(String(params_uri).length) {
					params_uri = params_uri + '&'+ i + '=' + item;
				} else {
					params_uri = '?'+ i + '=' + item;
				}

				url = this.uris.filter_carga_quotes;

			} else {

				if(params_uri) {
					params_uri = params_uri + '&'+ i + '=0';

				} else {
					params_uri = '?'+ i + '=0';


				}

				url = this.uris.filter_carga_quotes;
				// url = this.uris.carga_quote;
			}
		}

		if(parPage == '1'){

		} else {
			if(params_uri) {
				params_uri = params_uri + '&page=' + parPage;
			} else {
				params_uri = params_uri + '?page=' + parPage;
			}
		}

		url = url + params_uri;

        // emit
        // console.log('url', url);

        this.getContractors.emit(String(url));


        this.actual_page = parPage;
        if(this.actual_page > 1) {
          this.not_prev = false;
        }

        if(this.actual_page == this.totalPages.length -1) {
          this.not_next = true;
        }
	};

	nextBlockPages(params) {
		this.show_prev_block = true;

        if(params) {
          if(this.end > this.actual_page) {
            this.start = this.start + 1 ;
            this.end = this.end + 1;
          }
        } else {
          if(this.end < this.totalPages.length) {
            this.start = this.start + 5 ;
            this.end = this.end + 5;

            if(this.end == this.totalPages.length) {
                this.not_next = true;
            }
          } else {
            this.not_next = true;
          }
        }
	};

	col_by_zip_desde(param) {

		if (this.quote_selected.desde.country == 'Mexico') {

			if (String(param).length == 5) {
				let data = {
					zipCode: param,
					type: 1
				}
				this.cpParam.emit(data);
			} else {
				//this.quote.origen_estado = '';
				this.quote_list.desde.city = '';
				this.quote_list.desde.details.colony = '';
				this.cols_desde = [];
			}
		}
	};

	col_by_zip_hasta(param) {
		if (this.quote_selected.hasta.country == 'Mexico') {

			if (String(param).length == 5) {
				let data = {
					zipCode: param,
					type: 2
				}
				this.cpParam.emit(data);
			} else {

				//this.quote.destino_estado = '';
				this.quote_list.hasta.city = '';
				this.quote_list.hasta.details.colony = '';
				this.cols_hasta = [];

			}
		}
	};

	format_mes_anio(value){
	    if (value !== undefined && value !== "undefined" && value !== null && value !== "null" ){
            let date = new Date(value);
            value =  this.meses[date.getMonth()] +" "+ date.getFullYear();
	    }else{
	        value = ""
	    }
	    return value;
	};

	format_percentage(value, decimals=2) {
		value = parseFloat(value) * 100;
		value = value.toFixed(decimals) + '% ';
		return value;
	};

	show_document(url_file){
		if(url_file != '') {
			window.open(url_file, '_blank');
		}
	};
	edit_documents(){
	    this.edit_document = true;
	};



	// reCotizar(){
	// 	this.contractorsFilter.emit(this.quote_selected.contratante_name);
	// }

	// establece el tipo de cambio al cambiar la aseguradora
	establecerTipoCambio() {
		const valoresMoneda = {
			'MXN': 1,
			'USD': 2,
			'EUR': 3,
		}

		function obtenerValorTipoCambio(opcion: string): number {
			// manejamos el caso de hdi, chubb global y chubb internacional
			if (opcion.toUpperCase() === 'HDI' || opcion.toUpperCase() === 'CHUBB GLOBAL' || opcion.toUpperCase() === 'CHUBB INTERNACIONAL') {
				return valoresMoneda.USD || 2;
			}

			const coincide = opcion.match(/\b([A-Z]{3})\b(?:\s([A-Z]{3}))?/);
			if (coincide) {
				const codigoTipoMoneda = coincide[2] || coincide[1];
				return valoresMoneda[codigoTipoMoneda] || 0;
			}
			return 0;
		}

		const valorTipoCambio = obtenerValorTipoCambio(this.quote_list.compania.name);

		this.quote_selected.total_exchange = valorTipoCambio;
		this.quote_selected.valor_mercancia_exchange = valorTipoCambio;
		this.quote_selected.flete_exchange = valorTipoCambio;
		this.quote_selected.impuestos_nacionales_exchange = valorTipoCambio;
		this.quote_selected.gastos_operacionales_exchange = valorTipoCambio;
	}

	enSeleccionarContenedor(event: any) {
		this.contenedorSelect = event;
		this.quote_selected.descripcion_mercancia = this.contenedorSelect.nombre;
		this.quote_list.descripcion_mercancia = this.contenedorSelect.nombre;

		// procesar el ingreso del valor de la mercancia al cambiar el contenedor
		this.aplicarValorMercancia();
	}

	validarContenedorActual(){
		if (this.quote_selected && this.quote_selected.descripcion_mercancia) {
			const contenedor = this.contenedores.find(cont => cont.nombre === this.quote_selected.descripcion_mercancia);
			if (contenedor) {
				this.contenedorSelect = contenedor;
			}
		}
	}

	/**
	 * Remueve el contenedor de la lista de commodities
	 */
	private removerContenedorMercancia() {
		let certificado: any = this.quote_selected;
		let metodo: any = this.quote_selected && this.quote_selected.quote_type == 2 ? 'Documental' : 'Declaración';
		
		let enumMetodo = {
			Declaracion: 'Declaración'
		};

		if (certificado && metodo) {
			if ((certificado.compania && certificado.compania.name != this.enumAseguradora.ChubbUsd) || (metodo != enumMetodo.Declaracion)) {
				// en la lista de commodities, buscar el que tenga el nombre de 'Contenedor' y removerlo de la lista
				// el contenedor solo se debe de mostrar en chubb usd y en el metodo de declaracion
				if (this._commodity_list && this._commodity_list.length > 0) {
					this._commodity_list = this._commodity_list.filter((item: any) => {
						return item.name != this.enumContenedor.Contenedor;
					});
				} else {
					console.warn('No se encontró la lista de commodities');
				}
			}
		}
	}

}



// WEBPACK FOOTER //
// ../esscalo_funcionalidad/src/components/esscaloAdmin/esscalo-admin.component.ts